export const genderList = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Others", value: "Others" },
];

export const physicalStatusList = [
  { label: "Normal", value: "Normal" },
  { label: "Physically Challenged", value: "Physically Challenged" },
];

export const maritalStatusList = [
  { label: "Single", value: "Single" },
  { label: "Widowed", value: "Widowed" },
  { label: "divorced", value: "divorced" },
  { label: "Separated", value: "Separated" },
];
export const smokingHabitsList = [
  { label: "No", value: "No" },
  { label: "Yes", value: "Yes" },
  { label: "Occasionally", value: "Occasionally" },
];

export const drinkingHabitsList = [
  { label: "No", value: "No" },
  { label: "Yes", value: "Yes" },
  { label: "Social Drinking", value: "Social Drinking" },
];

export const bodyTypeList = [
  { label: "Slim", value: "Slim" },
  { label: "Average", value: "Average" },
  { label: "Athletic", value: "Athletic" },
  { label: "Heavy", value: "Heavy" },
];
export const eatingHabitsList = [
  { label: "Vegetarian", value: "Vegetarian" },
  { label: "Eggetarian", value: "Eggetarian" },
  { label: "Non Vegetarian", value: "Non Vegetarian" },
];

export const motherToungeList = [
  { value: "54", label: "Angika" },
  { value: "1", label: "Arunachali" },
  { value: "2", label: "Assamese" },
  { value: "3", label: "Awadhi" },
  { value: "4", label: "Bengali" },
  { value: "5", label: "Bhojpuri" },
  { value: "6", label: "Brij" },
  { value: "7", label: "Bihari" },
  { value: "53", label: "Badaga" },
  { value: "8", label: "Chatisgarhi" },
  { value: "9", label: "Dogri" },
  { value: "10", label: "English" },
  { value: "11", label: "French" },
  { value: "12", label: "Garhwali" },
  { value: "13", label: "Garo" },
  { value: "14", label: "Gujarati" },
  { value: "15", label: "Haryanvi" },
  { value: "16", label: "Himachali/Pahari" },
  { value: "17", label: "Hindi" },
  { value: "18", label: "Kanauji" },
  { value: "19", label: "Kannada" },
  { value: "20", label: "Kashmiri" },
  { value: "21", label: "Khandesi" },
  { value: "22", label: "Khasi" },
  { value: "23", label: "Konkani" },
  { value: "24", label: "Koshali" },
  { value: "25", label: "Kumaoni" },
  { value: "26", label: "Kutchi" },
  { value: "27", label: "Lepcha" },
  { value: "28", label: "Ladacki" },
  { value: "29", label: "Magahi" },
  { value: "30", label: "Maithili" },
  { value: "31", label: "Malayalam" },
  { value: "32", label: "Manipuri" },
  { value: "33", label: "Marathi" },
  { value: "34", label: "Marwari" },
  { value: "35", label: "Miji" },
  { value: "36", label: "Mizo" },
  { value: "37", label: "Monpa" },
  { value: "38", label: "Nicobarese" },
  { value: "39", label: "Nepali" },
  { value: "40", label: "Oriya" },
  { value: "41", label: "Punjabi" },
  { value: "42", label: "Rajasthani" },
  { value: "43", label: "Sanskrit" },
  { value: "44", label: "Santhali" },
  { value: "45", label: "Sindhi" },
  { value: "46", label: "Sourashtra" },
  { value: "47", label: "Tamil" },
  { value: "48", label: "Telugu" },
  { value: "49", label: "Tripuri" },
  { value: "50", label: "Tulu" },
  { value: "51", label: "Urdu" },
  { value: "55", label: "Bagri Rajasthani" },
  { value: "56", label: "Dhundhari/Jaipuri" },
  { value: "57", label: "Gujari/Gojari" },
  { value: "58", label: "Harauti" },
  { value: "59", label: "Lambadi" },
  { value: "60", label: "Malvi" },
  { value: "61", label: "Mewari" },
  { value: "62", label: "Mewati/Ahirwati" },
  { value: "63", label: "Nimadi" },
  { value: "64", label: "Shekhawati" },
  { value: "65", label: "Wagdi" },
];

export const nakshtramList = [
  { label: "Ashwini", value: "Ashwini" },
  { label: "Bharani", value: "Bharani" },
  { label: "Krittika", value: "Krittika" },
  { label: "Rohini", value: "Rohini" },
  { label: "Mrigashira", value: "Mrigashira" },
  { label: "Ardra", value: "Ardra" },
  { label: "Punarvasu", value: "Punarvasu" },
  { label: "Pushya", value: "Pushya" },
  { label: "Ashlesha", value: "Ashlesha" },
  { label: "Magha", value: "Magha" },
  { label: "Purva Phalguni", value: "" },
  { label: "Uttara Phalguni", value: "" },
  { label: "Hasta", value: "Hasta" },
  { label: "Chitra", value: "Chitra" },
  { label: "Swati", value: "Swati" },
  { label: "Vishaka", value: "Vishaka" },
  { label: "Anurada", value: "Anurada" },
  { label: "Jyeshta", value: "Jyeshta" },
  { label: "Mula", value: "Mula" },
  { label: "Purva Ashadha", value: "Purva Ashadha" },
  { label: "Uttara Ashadha", value: "Uttara Ashadha" },
  { label: "Shravana", value: "Shravana" },
  { label: "Dhanishta", value: "Dhanishta" },
  { label: "Shatabhishak", value: "Shatabhishak" },
  { label: "Purva Bhadrapada", value: "Purva Bhadrapada" },
  { label: "Uttara Bhadrapada", value: "Uttara Bhadrapada" },
  { label: "Revati", value: "Revati" },
];

export const raasilist = [
  { label: "Aries (Mesha)", value: "Aries (Mesha)" },
  { label: "Taurus (Vrishabha)", value: "Taurus (Vrishabha)" },
  { label: "Gemini (Mithuna)", value: "Gemini (Mithuna)" },
  { label: "Cancer (Karka)", value: "Cancer (Karka)" },
  { label: "Leo (Singha)", value: "Leo (Singha)" },
  { label: "Virgo (Kanya)", value: "Virgo (Kanya)" },
  { label: "Libra (Tula)", value: "Libra (Tula)" },
  { label: "Scorpio (Vrushchika)", value: "Scorpio (Vrushchika)" },
  { label: "Sagittarius (Dhanu)", value: "Sagittarius (Dhanu)" },
  { label: "Capricorn (Makara)", value: "Capricorn (Makara)" },
  { label: "Aquarius (Kumbha)", value: "Aquarius (Kumbha)" },
  { label: "Pisces (Meena)", value: "Pisces (Meena)" },
];

export const countries = [
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Aland Islands", value: "Aland Islands" },
  { label: "Albania", value: "Albania" },
  { label: "Algeria", value: "Algeria" },
  { label: "American Samoa", value: "American Samoa" },
  { label: "Andorra", value: "Andorra" },
  { label: "Angola", value: "Angola" },
  { label: "Anguilla", value: "Anguilla" },
  { value: "Antarctica", label: "Antarctica" },
  { value: "Antigua And Barbuda", label: "Antigua And Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Aruba", label: "Aruba" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas The", label: "Bahamas The" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bermuda", label: "Bermuda" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  {
    value: "Bonaire, Sint Eustatius and Saba",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Bouvet Island", label: "Bouvet Island" },
  { value: "Brazil", label: "Brazil" },
  {
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "Cape Verde", label: "Cape Verde" },
  { value: "Cayman Islands", label: "Cayman Islands" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "Christmas Island", label: "Christmas Island" },
  { value: "Cocos (Keeling) Islands", label: "Cocos (Keeling) Islands" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  { value: "Congo", label: "Congo" },
  { value: "Cook Islands", label: "Cook Islands" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "uraçao", label: "Curaçao" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czech Republic", label: "Czech Republic" },
  {
    value: "Democratic Republic of the Congo",
    label: "Democratic Republic of the Congo",
  },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "East Timor", label: "East Timor" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Falkland Islands", label: "Falkland Islands" },
  { value: "Faroe Islands", label: "Faroe Islands" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "French Guiana", label: "French Guiana" },
  { value: "French Polynesia", label: "French Polynesia" },
  {
    value: "French Southern Territories",
    label: "French Southern Territories",
  },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia The", label: "Gambia The" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Gibraltar", label: "Gibraltar" },
  { value: "Greece", label: "Greece" },
  { value: "Greenland", label: "Greenland" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guadeloupe", label: "Guadeloupe" },
  { value: "Guam", label: "Guam" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guernsey and Alderney", label: "Guernsey and Alderney" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  {
    value: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
  },
  { value: "Honduras", label: "Honduras" },
  { value: "Hong Kong S.A.R.", label: "Hong Kong S.A.R." },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jersey", label: "Jersey" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Macau S.A.R.", label: "Macau S.A.R." },
  { value: "Macedonia", label: "Macedonia" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Man (Isle of)", label: "Man (Isle of)" },
  { value: "Marshall Islands", label: "Marshall Islands" },
  { value: "Martinique", label: "Martinique" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mayotte", label: "Mayotte" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Caledonia", label: "New Caledonia" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "Niue", label: "Niue" },
  { value: "Norfolk Island", label: "Norfolk Island" },
  { value: "North Korea", label: "North Korea" },
  { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  {
    value: "Palestinian Territory Occupied",
    label: "Palestinian Territory Occupied",
  },
  { value: "Panama", label: "Panama" },
  { value: "Papua new Guinea", label: "Papua new Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Pitcairn Island", label: "Pitcairn Island" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Puerto Rico", label: "Puerto Rico" },
  { value: "Qatar", label: "Qatar" },
  { value: "Reunion", label: "Reunion" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Saint Helena", label: "Saint Helena" },
  { value: "Saint Kitts And Nevis", label: "Saint Kitts And Nevis" },
  { value: "Saint Lucia", label: "Saint Lucia" },
  { value: "Saint Pierre and Miquelon", label: "Saint Pierre and Miquelon" },
  {
    value: "Saint Vincent And The Grenadines",
    label: "Saint Vincent And The Grenadines",
  },
  { value: "Saint-Barthelemy", label: "Saint-Barthelemy" },
  { value: "Saint-Martin (French part)", label: "Saint-Martin (French part)" },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Sint Maarten (Dutch part)", label: "Sint Maarten (Dutch part)" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Georgia", label: "South Georgia" },
  { value: "South Korea", label: "South Korea" },
  { value: "South Sudan", label: "South Sudan" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "Surlabel", label: "Surlabel" },
  {
    value: "Svalbard And Jan Mayen Islands",
    label: "Svalbard And Jan Mayen Islands",
  },
  { value: "Swaziland", label: "Swaziland" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Togo", label: "Togo" },
  { value: "Tokelau", label: "Tokelau" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad And Tobago", label: "Trinidad And Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Turks And Caicos Islands", label: "Turks And Caicos Islands" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  {
    value: "United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  {
    value: "Vatican City State (Holy See)",
    label: "Vatican City State (Holy See)",
  },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Virgin Islands (British)", label: "Virgin Islands (British)" },
  { value: "Virgin Islands (US)", label: "Virgin Islands (US)" },
  { value: "Wallis And Futuna Islands", label: "Wallis And Futuna Islands" },
  { value: "Western Sahara", label: "Western Sahara" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { label: "Zimbabwe", value: "Zimbabwe" },
];

export const religionsList = [
  {
    id: "1",
    name: "Hindu",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "1",
        caste: "Ad Dharmi",
      },
      {
        id: "2",
        caste: "Adi Dravidar",
      },
      {
        id: "3",
        caste: "Agarwal",
      },
      {
        id: "4",
        caste: "Agnikula Kshatriya",
      },
      {
        id: "5",
        caste: "Agri",
      },
      {
        id: "6",
        caste: "Ahom",
      },
      {
        id: "7",
        caste: "Ambalavasi",
      },
      {
        id: "8",
        caste: "Arunthathiyar",
      },
      {
        id: "9",
        caste: "Arya Vysya",
      },
      {
        id: "10",
        caste: "Baidya",
      },
      {
        id: "11",
        caste: "Baishnab",
      },
      {
        id: "12",
        caste: "Baishya",
      },
      {
        id: "13",
        caste: "Balija",
      },
      {
        id: "14",
        caste: "Banik",
      },
      {
        id: "15",
        caste: "Baniya",
      },
      {
        id: "16",
        caste: "Barujibi",
      },
      {
        id: "17",
        caste: "Besta",
      },
      {
        id: "18",
        caste: "Bhandari",
      },
      {
        id: "19",
        caste: "Bhatia",
      },
      {
        id: "20",
        caste: "Bhavasar Kshatriya",
      },
      {
        id: "21",
        caste: "Bhovi",
      },
      {
        id: "22",
        caste: "Billava",
      },
      {
        id: "23",
        caste: "Boyar",
      },
      {
        id: "24",
        caste: "Brahmbatt",
      },
      {
        id: "25",
        caste: "Brahmin - Others",
      },
      {
        id: "26",
        caste: "Brahmin - Gurukkal",
      },
      {
        id: "26_ALT",
        caste: "Gurukkal Brahmin",
      },
      {
        id: "27",
        caste: "Brahmin - Iyengar",
      },
      {
        id: "27_ALT",
        caste: "Iyengar Brahmin",
      },
      {
        id: "28",
        caste: "Brahmin - Iyer",
      },
      {
        id: "28_ALT",
        caste: "Iyer Brahmin",
      },
      {
        id: "29",
        caste: "Jatav",
      },
      {
        id: "30",
        caste: "Chambhar",
      },
      {
        id: "31",
        caste: "Chandravanshi Kahar",
      },
      {
        id: "32",
        caste: "Chasa",
      },
      {
        id: "33",
        caste: "Chaudary",
      },
      {
        id: "34",
        caste: "Chaurasia",
      },
      {
        id: "35",
        caste: "Chettiar",
      },
      {
        id: "36",
        caste: "Chhetri",
      },
      {
        id: "37",
        caste: "CKP",
      },
      {
        id: "38",
        caste: "Coorgi",
      },
      {
        id: "39",
        caste: "Devadiga",
      },
      {
        id: "40",
        caste: "Devandra Kula Vellalar",
      },
      {
        id: "41",
        caste: "Devang Koshthi",
      },
      {
        id: "42",
        caste: "Devanga",
      },
      {
        id: "43",
        caste: "Dhangar",
      },
      {
        id: "44",
        caste: "Dheevara",
      },
      {
        id: "45",
        caste: "Dhiman",
      },
      {
        id: "46",
        caste: "Dhoba",
      },
      {
        id: "47",
        caste: "Madivala / Dhobi",
      },
      {
        id: "48",
        caste: "Ediga",
      },
      {
        id: "49",
        caste: "Ezhava",
      },
      {
        id: "50",
        caste: "Ezhuthachan",
      },
      {
        id: "51",
        caste: "Gabit",
      },
      {
        id: "52",
        caste: "Gandla",
      },
      {
        id: "53",
        caste: "Ganiga",
      },
      {
        id: "54",
        caste: "Garhwali",
      },
      {
        id: "55",
        caste: "Gavara",
      },
      {
        id: "56",
        caste: "Ghumar",
      },
      {
        id: "57",
        caste: "Goala",
      },
      {
        id: "58",
        caste: "Goan",
      },
      {
        id: "59",
        caste: "Gounder",
      },
      {
        id: "60",
        caste: "Gowda",
      },
      {
        id: "61",
        caste: "Gudia",
      },
      {
        id: "62",
        caste: "Gupta",
      },
      {
        id: "63",
        caste: "Intercaste",
      },
      {
        id: "64",
        caste: "Irani",
      },
      {
        id: "65",
        caste: "Jaiswal",
      },
      {
        id: "66",
        caste: "Jangam",
      },
      {
        id: "67",
        caste: "Jat",
      },
      {
        id: "68",
        caste: "Kaibarta",
      },
      {
        id: "69",
        caste: "Kalar",
      },
      {
        id: "70",
        caste: "Kalinga",
      },
      {
        id: "71",
        caste: "Kalita",
      },
      {
        id: "72",
        caste: "Kalwar",
      },
      {
        id: "73",
        caste: "Kamboj",
      },
      {
        id: "74",
        caste: "Kamma",
      },
      {
        id: "75",
        caste: "Kansari",
      },
      {
        id: "76",
        caste: "Kapu",
      },
      {
        id: "77",
        caste: "Karana",
      },
      {
        id: "78",
        caste: "Karmakar",
      },
      {
        id: "79",
        caste: "Karuneegar",
      },
      {
        id: "80",
        caste: "Kasar",
      },
      {
        id: "81",
        caste: "Kashyap",
      },
      {
        id: "82",
        caste: "Kayastha",
      },
      {
        id: "83",
        caste: "Khandayat",
      },
      {
        id: "84",
        caste: "Khandelwal",
      },
      {
        id: "85",
        caste: "Khatri",
      },
      {
        id: "86",
        caste: "Koli",
      },
      {
        id: "87",
        caste: "Kongu Vellala Gounder",
      },
      {
        id: "88",
        caste: "Konkani",
      },
      {
        id: "89",
        caste: "Kori",
      },
      {
        id: "90",
        caste: "Kshatriya",
      },
      {
        id: "91",
        caste: "Kudumbi",
      },
      {
        id: "92",
        caste: "Kulal",
      },
      {
        id: "93",
        caste: "Kulalar",
      },
      {
        id: "94",
        caste: "Kulita",
      },
      {
        id: "95",
        caste: "Kumbhakar",
      },
      {
        id: "96",
        caste: "Kumbhar",
      },
      {
        id: "97",
        caste: "Kumhar",
      },
      {
        id: "98",
        caste: "Kummari",
      },
      {
        id: "99",
        caste: "Kunbi",
      },
      {
        id: "100",
        caste: "Kurmi/Kurmi Kshatriya",
      },
      {
        id: "101",
        caste: "Kuruba",
      },
      {
        id: "102",
        caste: "Kuruhina Shetty",
      },
      {
        id: "103",
        caste: "Kurumbar",
      },
      {
        id: "104",
        caste: "Kutchi",
      },
      {
        id: "105",
        caste: "Lambadi",
      },
      {
        id: "106",
        caste: "Lingayath",
      },
      {
        id: "107",
        caste: "Lohana",
      },
      {
        id: "108",
        caste: "Lubana",
      },
      {
        id: "109",
        caste: "Madiga",
      },
      {
        id: "110",
        caste: "Mahajan",
      },
      {
        id: "111",
        caste: "Mahar",
      },
      {
        id: "112",
        caste: "Mahendra",
      },
      {
        id: "113",
        caste: "Maheshwari",
      },
      {
        id: "114",
        caste: "Mahishya",
      },
      {
        id: "115",
        caste: "Majabi",
      },
      {
        id: "116",
        caste: "Mala",
      },
      {
        id: "117",
        caste: "Mali",
      },
      {
        id: "118",
        caste: "Mallah",
      },
      {
        id: "119",
        caste: "Mangalorean",
      },
      {
        id: "120",
        caste: "Manipuri",
      },
      {
        id: "121",
        caste: "Munnuru Kapu",
      },
      {
        id: "122",
        caste: "Mapila",
      },
      {
        id: "123",
        caste: "Maratha",
      },
      {
        id: "124",
        caste: "Maruthuvar",
      },
      {
        id: "125",
        caste: "Matang",
      },
      {
        id: "126",
        caste: "Meena",
      },
      {
        id: "127",
        caste: "Meenavar",
      },
      {
        id: "128",
        caste: "Mehra",
      },
      {
        id: "129",
        caste: "Meru Darji",
      },
      {
        id: "129_ALT",
        caste: "Darji",
      },
      {
        id: "130",
        caste: "Mochi",
      },
      {
        id: "131",
        caste: "Modak",
      },
      {
        id: "132",
        caste: "Mogaveera",
      },
      {
        id: "133",
        caste: "Mudaliyar",
      },
      {
        id: "134",
        caste: "Mudiraj",
      },
      {
        id: "135",
        caste: "Devar/Thevar/Mukkulathor",
      },
      {
        id: "135_ALT",
        caste: "Mukkulathor",
      },
      {
        id: "136",
        caste: "Muthuraja / Mutharaiyar",
      },
      {
        id: "137",
        caste: "Nadar",
      },
      {
        id: "138",
        caste: "Nai / Nayi Brahmin",
      },
      {
        id: "139",
        caste: "Naicker",
      },
      {
        id: "140",
        caste: "Naidu",
      },
      {
        id: "141",
        caste: "Naik",
      },
      {
        id: "142",
        caste: "Nair",
      },
      {
        id: "143",
        caste: "Namasudra / Namassej",
      },
      {
        id: "144",
        caste: "Napit",
      },
      {
        id: "145",
        caste: "Nayaka",
      },
      {
        id: "146",
        caste: "Nepali",
      },
      {
        id: "147",
        caste: "Nhavi",
      },
      {
        id: "148",
        caste: "Oswal",
      },
      {
        id: "149",
        caste: "Padmasali",
      },
      {
        id: "150",
        caste: "Pal",
      },
      {
        id: "151",
        caste: "Panchal",
      },
      {
        id: "152",
        caste: "Panicker",
      },
      {
        id: "153",
        caste: "Parkavakulam / Udayar",
      },
      {
        id: "154",
        caste: "Parsi",
      },
      {
        id: "155",
        caste: "Pasi",
      },
      {
        id: "156",
        caste: "Patel",
      },
      {
        id: "157",
        caste: "Patnaick/Sistakaranam",
      },
      {
        id: "158",
        caste: "Patra",
      },
      {
        id: "159",
        caste: "Pillai",
      },
      {
        id: "160",
        caste: "Porwal",
      },
      {
        id: "161",
        caste: "Prajapati",
      },
      {
        id: "162",
        caste: "Rajaka / Vannar",
      },
      {
        id: "163",
        caste: "Rajastani",
      },
      {
        id: "164",
        caste: "Rajbonshi",
      },
      {
        id: "165",
        caste: "Rajput",
      },
      {
        id: "166",
        caste: "Ramdasia",
      },
      {
        id: "167",
        caste: "Ramgariah",
      },
      {
        id: "168",
        caste: "Ravidasia",
      },
      {
        id: "169",
        caste: "Rawat",
      },
      {
        id: "170",
        caste: "Reddy",
      },
      {
        id: "171",
        caste: "Sadgope",
      },
      {
        id: "172",
        caste: "Saha",
      },
      {
        id: "173",
        caste: "Sahu",
      },
      {
        id: "174",
        caste: "Saini",
      },
      {
        id: "175",
        caste: "Saliya",
      },
      {
        id: "176",
        caste: "SC",
      },
      {
        id: "177",
        caste: "Senai Thalaivar",
      },
      {
        id: "178",
        caste: "Bunt (Shetty)",
      },
      {
        id: "178_ALT",
        caste: "Shetty",
      },
      {
        id: "179",
        caste: "Shimpi/Namdev",
      },
      {
        id: "180",
        caste: "Sindhi",
      },
      {
        id: "181",
        caste: "Sindhi-Amil",
      },
      {
        id: "181_ALT",
        caste: "Amil Sindhi",
      },
      {
        id: "182",
        caste: "Sindhi-Baibhand",
      },
      {
        id: "182_ALT",
        caste: "Baibhand Sindhi",
      },
      {
        id: "183",
        caste: "Sindhi-Bhanusali",
      },
      {
        id: "183_ALT",
        caste: "Bhanusali Sindhi",
      },
      {
        id: "184",
        caste: "Sindhi-Bhatia",
      },
      {
        id: "184_ALT",
        caste: "Bhatia Sindhi",
      },
      {
        id: "185",
        caste: "Sindhi-Chhapru",
      },
      {
        id: "185_ALT",
        caste: "Chhapru Sindhi",
      },
      {
        id: "186",
        caste: "Sindhi-Dadu",
      },
      {
        id: "186_ALT",
        caste: "Dadu Sindhi",
      },
      {
        id: "187",
        caste: "Sindhi-Hyderabadi",
      },
      {
        id: "187_ALT",
        caste: "Hyderabadi Sindhi",
      },
      {
        id: "188",
        caste: "Sindhi-Larai",
      },
      {
        id: "188_ALT",
        caste: "Larai Sindhi",
      },
      {
        id: "189",
        caste: "Sindhi-Larkana",
      },
      {
        id: "189_ALT",
        caste: "Larkana Sindhi",
      },
      {
        id: "190",
        caste: "Sindhi-Lohana",
      },
      {
        id: "190_ALT",
        caste: "Lohana Sindhi",
      },
      {
        id: "191",
        caste: "Sindhi-Rohiri",
      },
      {
        id: "191_ALT",
        caste: "Rohiri Sindhi",
      },
      {
        id: "192",
        caste: "Sindhi-Sahiti",
      },
      {
        id: "192_ALT",
        caste: "Sahiti Sindhi",
      },
      {
        id: "193",
        caste: "Sindhi-Sakkhar",
      },
      {
        id: "193_ALT",
        caste: "Sakkhar Sindhi",
      },
      {
        id: "194",
        caste: "Sindhi-Sehwani",
      },
      {
        id: "194_ALT",
        caste: "Sehwani Sindhi",
      },
      {
        id: "195",
        caste: "Sindhi-Shikarpuri",
      },
      {
        id: "195_ALT",
        caste: "Shikarpuri Sindhi",
      },
      {
        id: "196",
        caste: "Sindhi-Thatai",
      },
      {
        id: "196_ALT",
        caste: "Thatai Sindhi",
      },
      {
        id: "197",
        caste: "SKP",
      },
      {
        id: "198",
        caste: "Sonar",
      },
      {
        id: "199",
        caste: "Soni",
      },
      {
        id: "200",
        caste: "Sourashtra",
      },
      {
        id: "201",
        caste: "Sundhi",
      },
      {
        id: "202",
        caste: "Suthar",
      },
      {
        id: "203",
        caste: "Swakula Sali",
      },
      {
        id: "204",
        caste: "Tamboli",
      },
      {
        id: "205",
        caste: "Tanti",
      },
      {
        id: "206",
        caste: "Tantubai",
      },
      {
        id: "207",
        caste: "Telaga",
      },
      {
        id: "208",
        caste: "Teli",
      },
      {
        id: "209",
        caste: "Thakkar",
      },
      {
        id: "210",
        caste: "Thakur",
      },
      {
        id: "211",
        caste: "Thigala",
      },
      {
        id: "212",
        caste: "Thiyya",
      },
      {
        id: "213",
        caste: "Tili",
      },
      {
        id: "214",
        caste: "ST",
      },
      {
        id: "215",
        caste: "Sagara (Uppara)",
      },
      {
        id: "216",
        caste: "Vaddera",
      },
      {
        id: "217",
        caste: "Vaish",
      },
      {
        id: "218",
        caste: "Vaishnav",
      },
      {
        id: "219",
        caste: "Vaishnava",
      },
      {
        id: "220",
        caste: "Vaishya",
      },
      {
        id: "221",
        caste: "Vaishya Vani",
      },
      {
        id: "222",
        caste: "Valmiki",
      },
      {
        id: "223",
        caste: "Vania",
      },
      {
        id: "224",
        caste: "Vaniya",
      },
      {
        id: "225",
        caste: "Vanjara",
      },
      {
        id: "226",
        caste: "Vanjari",
      },
      {
        id: "227",
        caste: "Vankar",
      },
      {
        id: "228",
        caste: "Vannar",
      },
      {
        id: "229",
        caste: "Vannia Kula Kshatriyar",
      },
      {
        id: "230",
        caste: "Veera Saivam",
      },
      {
        id: "231",
        caste: "Velama",
      },
      {
        id: "232",
        caste: "Vellalar",
      },
      {
        id: "233",
        caste: "Veluthedathu Nair",
      },
      {
        id: "234",
        caste: "Vilakkithala Nair",
      },
      {
        id: "235",
        caste: "Viswabrahmin",
      },
      {
        id: "236",
        caste: "Vishwakarma",
      },
      {
        id: "237",
        caste: "Vokkaliga",
      },
      {
        id: "238",
        caste: "Vysya",
      },
      {
        id: "239",
        caste: "Yadav",
      },
      {
        id: "240",
        caste: "Brahmin - Bhumihar",
      },
      {
        id: "240_ALT",
        caste: "Bhumihar Brahmin",
      },
      {
        id: "241",
        caste: "Brahmin - Kanyakubj",
      },
      {
        id: "241_ALT",
        caste: "Kanyakubj Brahmin",
      },
      {
        id: "242",
        caste: "Brahmin - Gaur",
      },
      {
        id: "242_ALT",
        caste: "Gaur Brahmin",
      },
      {
        id: "243",
        caste: "Brahmin - Maithil",
      },
      {
        id: "243_ALT",
        caste: "Maithil Brahmin",
      },
      {
        id: "244",
        caste: "Brahmin - Saryuparin",
      },
      {
        id: "244_ALT",
        caste: "Saryuparin Brahmin",
      },
      {
        id: "245",
        caste: "Brahmin - Garhwali",
      },
      {
        id: "245_ALT",
        caste: "Garhwali Brahmin",
      },
      {
        id: "246",
        caste: "Brahmin - Pandit",
      },
      {
        id: "246_ALT",
        caste: "Pandit Brahmin",
      },
      {
        id: "247",
        caste: "Brahmin - Sanadya",
      },
      {
        id: "247_ALT",
        caste: "Sanadya Brahmin",
      },
      {
        id: "248",
        caste: "Brahmin - Kumaoni",
      },
      {
        id: "248_ALT",
        caste: "Kumaoni Brahmin",
      },
      {
        id: "249",
        caste: "Brahmin - Tyagi",
      },
      {
        id: "249_ALT",
        caste: "Tyagi Brahmin",
      },
      {
        id: "250",
        caste: "Goud",
      },
      {
        id: "251",
        caste: "Kadava Patel",
      },
      {
        id: "252",
        caste: "Leva patel",
      },
      {
        id: "253",
        caste: "Leva patil",
      },
      {
        id: "254",
        caste: "Brahmin - Barendra",
      },
      {
        id: "254_ALT",
        caste: "Barendra Brahmin",
      },
      {
        id: "255",
        caste: "Brahmin - Kulin",
      },
      {
        id: "255_ALT",
        caste: "Kulin Brahmin",
      },
      {
        id: "256",
        caste: "Brahmin - Rarhi",
      },
      {
        id: "256_ALT",
        caste: "Rarhi Brahmin",
      },
      {
        id: "257",
        caste: "Brahmin - Rudraj",
      },
      {
        id: "257_ALT",
        caste: "Rudraj Brahmin",
      },
      {
        id: "258",
        caste: "Brahmin - Namboodiri",
      },
      {
        id: "258_ALT",
        caste: "Namboodiri Brahmin",
      },
      {
        id: "259",
        caste: "Brahmin - Saraswat",
      },
      {
        id: "259_ALT",
        caste: "Saraswat Brahmin",
      },
      {
        id: "260",
        caste: "Brahmin - Anavil",
      },
      {
        id: "260_ALT",
        caste: "Anavil Brahmin",
      },
      {
        id: "261",
        caste: "Brahmin - Audichya",
      },
      {
        id: "261_ALT",
        caste: "Audichya Brahmin",
      },
      {
        id: "262",
        caste: "Brahmin - Goswami/Gosavi",
      },
      {
        id: "262_ALT",
        caste: "Goswami/Gosavi Brahmin",
      },
      {
        id: "263",
        caste: "Brahmin - Modh",
      },
      {
        id: "263_ALT",
        caste: "Modh Brahmin",
      },
      {
        id: "264",
        caste: "Brahmin - Nagar",
      },
      {
        id: "264_ALT",
        caste: "Nagar Brahmin",
      },
      {
        id: "265",
        caste: "Brahmin - Shrimali",
      },
      {
        id: "265_ALT",
        caste: "Shrimali Brahmin",
      },
      {
        id: "266",
        caste: "Brahmin - Vyas",
      },
      {
        id: "266_ALT",
        caste: "Vyas Brahmin",
      },
      {
        id: "267",
        caste: "Brahmin - Bhatt",
      },
      {
        id: "267_ALT",
        caste: "Bhatt Brahmin",
      },
      {
        id: "268",
        caste: "Brahmin - Sakaldwipi",
      },
      {
        id: "268_ALT",
        caste: "Sakaldwipi Brahmin",
      },
      {
        id: "269",
        caste: "Brahmin - Daivadnya",
      },
      {
        id: "269_ALT",
        caste: "Daivadnya Brahmin",
      },
      {
        id: "270",
        caste: "Brahmin - Deshastha",
      },
      {
        id: "270_ALT",
        caste: "Deshastha Brahmin",
      },
      {
        id: "271",
        caste: "Brahmin - Havyaka",
      },
      {
        id: "271_ALT",
        caste: "Havyaka Brahmin",
      },
      {
        id: "272",
        caste: "Brahmin - Hoysala",
      },
      {
        id: "272_ALT",
        caste: "Hoysala Brahmin",
      },
      {
        id: "273",
        caste: "Brahmin - Karhade",
      },
      {
        id: "273_ALT",
        caste: "Karhade Brahmin",
      },
      {
        id: "274",
        caste: "Brahmin - Kota",
      },
      {
        id: "274_ALT",
        caste: "Kota Brahmin",
      },
      {
        id: "275",
        caste: "Brahmin - Madhwa",
      },
      {
        id: "275_ALT",
        caste: "Madhwa Brahmin",
      },
      {
        id: "276",
        caste: "Brahmin - Sanketi",
      },
      {
        id: "276_ALT",
        caste: "Sanketi Brahmin",
      },
      {
        id: "277",
        caste: "Brahmin - Shivhalli",
      },
      {
        id: "277_ALT",
        caste: "Shivhalli Brahmin",
      },
      {
        id: "278",
        caste: "Brahmin - Smartha",
      },
      {
        id: "278_ALT",
        caste: "Smartha Brahmin",
      },
      {
        id: "279",
        caste: "Brahmin - Sri Vaishnava",
      },
      {
        id: "279_ALT",
        caste: "Sri Vaishnava Brahmin",
      },
      {
        id: "280",
        caste: "Brahmin - Stanika",
      },
      {
        id: "280_ALT",
        caste: "Stanika Brahmin",
      },
      {
        id: "281",
        caste: "Arora",
      },
      {
        id: "282",
        caste: "Brahmin - Mohyal",
      },
      {
        id: "282_ALT",
        caste: "Mohyal Brahmin",
      },
      {
        id: "283",
        caste: "Brahmin - Kokanastha",
      },
      {
        id: "283_ALT",
        caste: "Kokanastha Brahmin",
      },
      {
        id: "284",
        caste: "Brahmin - Rigvedi",
      },
      {
        id: "284_ALT",
        caste: "Rigvedi Brahmin",
      },
      {
        id: "285",
        caste: "Brahmin - Vaidiki",
      },
      {
        id: "285_ALT",
        caste: "Vaidiki Brahmin",
      },
      {
        id: "286",
        caste: "Brahmin - Danua",
      },
      {
        id: "286_ALT",
        caste: "Danua Brahmin",
      },
      {
        id: "287",
        caste: "Brahmin - Halua",
      },
      {
        id: "287_ALT",
        caste: "Halua Brahmin",
      },
      {
        id: "288",
        caste: "Brahmin - Jhadua",
      },
      {
        id: "288_ALT",
        caste: "Jhadua Brahmin",
      },
      {
        id: "289",
        caste: "Brahmin - Panda",
      },
      {
        id: "289_ALT",
        caste: "Panda Brahmin",
      },
      {
        id: "290",
        caste: "Brahmin - Dhiman",
      },
      {
        id: "290_ALT",
        caste: "Dhiman Brahmin",
      },
      {
        id: "291",
        caste: "Brahmin - Dravida",
      },
      {
        id: "291_ALT",
        caste: "Dravida Brahmin",
      },
      {
        id: "292",
        caste: "Brahmin - Niyogi",
      },
      {
        id: "292_ALT",
        caste: "Niyogi Brahmin",
      },
      {
        id: "293",
        caste: "Settibalija",
      },
      {
        id: "294",
        caste: "Arekatica",
      },
      {
        id: "295",
        caste: "Banjara",
      },
      {
        id: "296",
        caste: "Barai",
      },
      {
        id: "297",
        caste: "Bari",
      },
      {
        id: "298",
        caste: "Bhatraju",
      },
      {
        id: "299",
        caste: "Brahmin - Jangid",
      },
      {
        id: "299_ALT",
        caste: "Jangid Brahmin",
      },
      {
        id: "301",
        caste: "Chippolu (Mera)",
      },
      {
        id: "301_ALT",
        caste: "Mera",
      },
      {
        id: "302",
        caste: "Dumal",
      },
      {
        id: "303",
        caste: "Dusadh (Paswan)",
      },
      {
        id: "303_ALT",
        caste: "Paswan",
      },
      {
        id: "304",
        caste: "Gawali",
      },
      {
        id: "305",
        caste: "Ghisadi",
      },
      {
        id: "306",
        caste: "Gomantak",
      },
      {
        id: "307",
        caste: "Gondhali",
      },
      {
        id: "308",
        caste: "Gramani",
      },
      {
        id: "309",
        caste: "Gurav",
      },
      {
        id: "310",
        caste: "Gujjar",
      },
      {
        id: "311",
        caste: "Guptan",
      },
      {
        id: "312",
        caste: "Gurjar",
      },
      {
        id: "313",
        caste: "Hugar (Jeer)",
      },
      {
        id: "313_ALT",
        caste: "Jeer",
      },
      {
        id: "314",
        caste: "Jaalari",
      },
      {
        id: "315",
        caste: "Jandra",
      },
      {
        id: "316",
        caste: "Jangra - Brahmin",
      },
      {
        id: "317",
        caste: "Jogi (Nath)",
      },
      {
        id: "317_ALT",
        caste: "Nath",
      },
      {
        id: "318",
        caste: "Kachara",
      },
      {
        id: "319",
        caste: "Kalinga Vysya",
      },
      {
        id: "320",
        caste: "Katiya",
      },
      {
        id: "321",
        caste: "Kharwar",
      },
      {
        id: "322",
        caste: "Kokanastha Maratha",
      },
      {
        id: "323",
        caste: "Kumawat",
      },
      {
        id: "324",
        caste: "Kuravan",
      },
      {
        id: "325",
        caste: "Kurmi",
      },
      {
        id: "326",
        caste: "Kushwaha (Koiri)",
      },
      {
        id: "326_ALT",
        caste: "Koiri",
      },
      {
        id: "327",
        caste: "Lodhi Rajput",
      },
      {
        id: "328",
        caste: "Mathur",
      },
      {
        id: "329",
        caste: "Naagavamsam",
      },
      {
        id: "330",
        caste: "Nagaralu",
      },
      {
        id: "331",
        caste: "Nambiar",
      },
      {
        id: "332",
        caste: "Brahmin - Narmadiya",
      },
      {
        id: "332_ALT",
        caste: "Narmadiya Brahmin",
      },
      {
        id: "333",
        caste: "Neeli",
      },
      {
        id: "334",
        caste: "Otari",
      },
      {
        id: "335",
        caste: "Partraj",
      },
      {
        id: "336",
        caste: "Perika",
      },
      {
        id: "337",
        caste: "Brahmin - Pushkarna",
      },
      {
        id: "337_ALT",
        caste: "Pushkarna Brahmin",
      },
      {
        id: "338",
        caste: "Relli",
      },
      {
        id: "339",
        caste: "Chattada Sri Vaishnava",
      },
      {
        id: "340",
        caste: "Savji",
      },
      {
        id: "341",
        caste: "Senguntha Mudaliyar",
      },
      {
        id: "342",
        caste: "Sozhiya Vellalar",
      },
      {
        id: "343",
        caste: "Sugali (Naika)",
      },
      {
        id: "343_ALT",
        caste: "Naika",
      },
      {
        id: "344",
        caste: "Sunari",
      },
      {
        id: "346",
        caste: "Togata",
      },
      {
        id: "347",
        caste: "Tonk Kshatriya",
      },
      {
        id: "348",
        caste: "Turupu Kapu",
      },
      {
        id: "349",
        caste: "Urs",
      },
      {
        id: "350",
        caste: "Valluvan",
      },
      {
        id: "351",
        caste: "Variar",
      },
      {
        id: "352",
        caste: "Varshney",
      },
      {
        id: "353",
        caste: "Velaan",
      },
      {
        id: "354",
        caste: "Brahmin - Velanadu",
      },
      {
        id: "354_ALT",
        caste: "Velanadu Brahmin",
      },
      {
        id: "355",
        caste: "Vettuva Gounder",
      },
      {
        id: "356",
        caste: "Vada Balija",
      },
      {
        id: "357",
        caste: "Yellapu",
      },
      {
        id: "358",
        caste: "Raigar",
      },
      {
        id: "673",
        caste: "Badaga",
      },
      {
        id: "675",
        caste: "Thakore",
      },
      {
        id: "676",
        caste: "Pathare Prabhu",
      },
      {
        id: "677",
        caste: "Lohar",
      },
      {
        id: "680",
        caste: "Brahmin - Gujar Gaur",
      },
      {
        id: "680_ALT",
        caste: "Gujar Gaur Brahmin",
      },
      {
        id: "681",
        caste: "Brahmin - Sikhwal",
      },
      {
        id: "681_ALT",
        caste: "Sikhwal Brahmin",
      },
      {
        id: "682",
        caste: "Srisayana",
      },
      {
        id: "683",
        caste: "Poosala",
      },
      {
        id: "684",
        caste: "Ganda",
      },
      {
        id: "685",
        caste: "Ayyaraka",
      },
      {
        id: "686",
        caste: "Rajbhar",
      },
      {
        id: "687",
        caste: "Brahmin - Vaikhanasa",
      },
      {
        id: "687_ALT",
        caste: "Vaikhanasa Brahmin",
      },
      {
        id: "688",
        caste: "Pandaram",
      },
      {
        id: "689",
        caste: "Koli Mahadev",
      },
      {
        id: "690",
        caste: "Bishnoi/Vishnoi",
      },
      {
        id: "691",
        caste: "Kahar",
      },
      {
        id: "692",
        caste: "Adi Andhra",
      },
      {
        id: "693",
        caste: "Adi Karnataka",
      },
      {
        id: "694",
        caste: "Brahmin - Paliwal",
      },
      {
        id: "695",
        caste: "Kalal",
      },
      {
        id: "696",
        caste: "Urali Gounder",
      },
      {
        id: "698",
        caste: "Bagdi",
      },
      {
        id: "699",
        caste: "Bajantri",
      },
      {
        id: "700",
        caste: "Banayat Oriya",
      },
      {
        id: "701",
        caste: "Baniya - Bania",
      },
      {
        id: "702",
        caste: "Baniya - Kumuti",
      },
      {
        id: "703",
        caste: "Baria",
      },
      {
        id: "704",
        caste: "Bhoi",
      },
      {
        id: "705",
        caste: "Bondili",
      },
      {
        id: "706",
        caste: "Brahmin - Khandelwal",
      },
      {
        id: "707",
        caste: "Brahmin - Jyotish",
      },
      {
        id: "708",
        caste: "Brahmin - Pareek",
      },
      {
        id: "709",
        caste: "Brajastha Maithil",
      },
      {
        id: "711",
        caste: "Chennadasar",
      },
      {
        id: "712",
        caste: "Dommala",
      },
      {
        id: "713",
        caste: "Gatti",
      },
      {
        id: "714",
        caste: "Halba Koshti",
      },
      {
        id: "715",
        caste: "Helava",
      },
      {
        id: "716",
        caste: "Jetty/Malla",
      },
      {
        id: "717",
        caste: "Kavuthiyya/Ezhavathy",
      },
      {
        id: "718",
        caste: "Kharwa",
      },
      {
        id: "719",
        caste: "Kirar",
      },
      {
        id: "720",
        caste: "Koli Patel",
      },
      {
        id: "721",
        caste: "Korama",
      },
      {
        id: "722",
        caste: "Kosthi",
      },
      {
        id: "723",
        caste: "Krishnavaka",
      },
      {
        id: "724",
        caste: "Loniya",
      },
      {
        id: "725",
        caste: "Rajpurohit",
      },
      {
        id: "726",
        caste: "Ramanandi",
      },
      {
        id: "727",
        caste: "Ramoshi",
      },
      {
        id: "728",
        caste: "Ror",
      },
      {
        id: "729",
        caste: "Surya Balija",
      },
      {
        id: "730",
        caste: "Vanika Vyshya",
      },
      {
        id: "731",
        caste: "Jijhotia Brahmin",
      },
      {
        id: "731_ALT",
        caste: "Brahmin Jijhotia",
      },
      {
        id: "732",
        caste: "Dhor / Kakkayya",
      },
      {
        id: "733",
        caste: "Malviya Brahmin",
      },
      {
        id: "733_ALT",
        caste: "Brahmin Malviya",
      },
      {
        id: "734",
        caste: "Brahmin - Embrandiri",
      },
      {
        id: "734_ALT",
        caste: "Embrandiri Brahmin",
      },
      {
        id: "735",
        caste: "Maurya / Shakya",
      },
      {
        id: "736",
        caste: "Sathwara",
      },
      {
        id: "737",
        caste: "Bhoyar",
      },
      {
        id: "738",
        caste: "Chalawadi and Holeya",
      },
      {
        id: "739",
        caste: "Kalanji",
      },
      {
        id: "740",
        caste: "Devrukhe Brahmin",
      },
      {
        id: "741",
        caste: "Ahir Shimpi",
      },
      {
        id: "742",
        caste: "Balija Naidu",
      },
      {
        id: "743",
        caste: "Ediga /Goud (Balija)",
      },
      {
        id: "744",
        caste: "Gajula / Kavarai",
      },
      {
        id: "748",
        caste: "Setty Balija",
      },
      {
        id: "750",
        caste: "Kavara",
      },
      {
        id: "751",
        caste: "Linga Balija",
      },
      {
        id: "752",
        caste: "Musukama",
      },
      {
        id: "753",
        caste: "Namdarlu",
      },
      {
        id: "754",
        caste: "Pagadala",
      },
      {
        id: "755",
        caste: "Balija Reddy",
      },
      {
        id: "756",
        caste: "Thota",
      },
      {
        id: "757",
        caste: "Komti /Arya Vaishya",
      },
      {
        id: "758",
        caste: "Thiyya Thandan",
      },
      {
        id: "759",
        caste: "Madhesiya/Kanu/Halwai",
      },
      {
        id: "760",
        caste: "Shaw / Sahu/Teli",
      },
      {
        id: "761",
        caste: "Nabit",
      },
      {
        id: "762",
        caste: "Brahmin - Dadhich",
      },
      {
        id: "763",
        caste: "Brahmin - Koteshwara / Kota (Madhwa )",
      },
      {
        id: "764",
        caste: "Brahmin - Shivalli (Madhva)",
      },
      {
        id: "765",
        caste: "Brahmin - Shukla Yajurvedi",
      },
      {
        id: "766",
        caste: "24 Manai Telugu Chettiar",
      },
      {
        id: "767",
        caste: "Modikarlu",
      },
      {
        id: "768",
        caste: "Gandla / Ganiga",
      },
      {
        id: "769",
        caste: "Parvatha Rajakulam",
      },
      {
        id: "770",
        caste: "Pattinavar",
      },
      {
        id: "771",
        caste: "Sadhu Chetty",
      },
      {
        id: "772",
        caste: "Telugupatti",
      },
      {
        id: "775",
        caste: "Ezhava Panicker",
      },
      {
        id: "776",
        caste: "Ezhava Thandan",
      },
      {
        id: "777",
        caste: "Gounder - Kongu Vellala Gounder",
      },
      {
        id: "778",
        caste: "Gounder - Nattu Gounder",
      },
      {
        id: "779",
        caste: "Gounder - Urali Gounder",
      },
      {
        id: "780",
        caste: "Gounder - Vanniya Kula Kshatriyar",
      },
      {
        id: "781",
        caste: "Gounder - Vettuva Gounder",
      },
      {
        id: "782",
        caste: "Gowda - Kuruba Gowda",
      },
      {
        id: "783",
        caste: "Kanykubj Bania",
      },
      {
        id: "785",
        caste: "Kapu Naidu",
      },
      {
        id: "786",
        caste: "Ontari",
      },
      {
        id: "787",
        caste: "Kayastha (Bengali)",
      },
      {
        id: "788",
        caste: "Nattu Gounder",
      },
      {
        id: "790",
        caste: "Perika/Puragiri Kshatriya",
      },
      {
        id: "791",
        caste: "Thogata Veera Kshatriya",
      },
      {
        id: "792",
        caste: "Haihaivanshi",
      },
      {
        id: "793",
        caste: "Kshatriya Kurmi",
      },
      {
        id: "797",
        caste: "96 Kuli Maratha",
      },
      {
        id: "800",
        caste: "Aramari / Gabit",
      },
      {
        id: "801",
        caste: "Deshmukh",
      },
      {
        id: "802",
        caste: "Jhadav",
      },
      {
        id: "803",
        caste: "Maratha Kshatriya",
      },
      {
        id: "804",
        caste: "Kunbi Lonari",
      },
      {
        id: "805",
        caste: "Kunbi Maratha",
      },
      {
        id: "806",
        caste: "Kunbi Tirale",
      },
      {
        id: "807",
        caste: "Malwani",
      },
      {
        id: "808",
        caste: "Patil",
      },
      {
        id: "810",
        caste: "Saiva Pillai Tirunelveli",
      },
      {
        id: "811",
        caste: "Sengunthar/Kaikolar",
      },
      {
        id: "812",
        caste: "Thondai Mandala Vellalar",
      },
      {
        id: "813",
        caste: "Kongu Nadar",
      },
      {
        id: "814",
        caste: "Naicker - Vanniya Kula Kshatriyar",
      },
      {
        id: "816",
        caste: "Kamma Naidu",
      },
      {
        id: "818",
        caste: "Vadugan",
      },
      {
        id: "819",
        caste: "Yadava Naidu",
      },
      {
        id: "821",
        caste: "Vilakithala Nair",
      },
      {
        id: "823",
        caste: "Brahmin - Anaviln Desai",
      },
      {
        id: "827",
        caste: "Brahmin - Shri Gaud",
      },
      {
        id: "832",
        caste: "Brahmin - Rarhi/Radhi",
      },
      {
        id: "834",
        caste: "Brahmin - Baidhiki/Vaidhiki",
      },
      {
        id: "835",
        caste: "Brahmin - Khedaval",
      },
      {
        id: "836",
        caste: "Thogata Veerakshathriya",
      },
      {
        id: "839",
        caste: "Anjana (Chowdary) Patel",
      },
      {
        id: "840",
        caste: "Desikar",
      },
      {
        id: "841",
        caste: "Karkathar",
      },
      {
        id: "842",
        caste: "Othuvaar",
      },
      {
        id: "843",
        caste: "Saiva Pillai Thanjavur",
      },
      {
        id: "844",
        caste: "Desikar Thanjavur",
      },
      {
        id: "845",
        caste: "Pallan / Devandra Kula Vellalan",
      },
      {
        id: "849",
        caste: "Kori/Koli",
      },
      {
        id: "850",
        caste: "Kuruva",
      },
      {
        id: "851",
        caste: "Rohit / Chamar",
      },
      {
        id: "852",
        caste: "Sambava",
      },
      {
        id: "853",
        caste: "Vaishnav Dishaval",
      },
      {
        id: "854",
        caste: "Vaishnav Kapol",
      },
      {
        id: "855",
        caste: "Vaishnav Khadyata",
      },
      {
        id: "856",
        caste: "Vaishnav Lad",
      },
      {
        id: "857",
        caste: "Vaishnav Modh",
      },
      {
        id: "858",
        caste: "Vaishnav Porvad",
      },
      {
        id: "859",
        caste: "Vaishnav Shrimali",
      },
      {
        id: "860",
        caste: "Vaishnav Sorathaiya",
      },
      {
        id: "861",
        caste: "Vaishnav Vania",
      },
      {
        id: "862",
        caste: "Agrahari",
      },
      {
        id: "863",
        caste: "Asathi",
      },
      {
        id: "864",
        caste: "Barnwal",
      },
      {
        id: "865",
        caste: "Dosar / Dusra",
      },
      {
        id: "866",
        caste: "Gahoi",
      },
      {
        id: "867",
        caste: "Kasaundhan",
      },
      {
        id: "868",
        caste: "Keshri (Kesarwani)",
      },
      {
        id: "869",
        caste: "Maheshwari / Meshri",
      },
      {
        id: "870",
        caste: "Mahuri",
      },
      {
        id: "871",
        caste: "Nema",
      },
      {
        id: "872",
        caste: "Patwa",
      },
      {
        id: "873",
        caste: "Porwal / Porwar",
      },
      {
        id: "874",
        caste: "Rastogi",
      },
      {
        id: "875",
        caste: "Rauniar",
      },
      {
        id: "876",
        caste: "Ummar / Umre / Bagaria",
      },
      {
        id: "877",
        caste: "Vani / Vaishya",
      },
      {
        id: "878",
        caste: "Varshney (Barahseni)",
      },
      {
        id: "879",
        caste: "Vijayvargia",
      },
      {
        id: "880",
        caste: "Choudhary",
      },
      {
        id: "881",
        caste: "Gandha Vanika",
      },
      {
        id: "882",
        caste: "Lad",
      },
      {
        id: "883",
        caste: "Modi",
      },
      {
        id: "884",
        caste: "Padmavati Porwal",
      },
      {
        id: "885",
        caste: "Rathi",
      },
      {
        id: "886",
        caste: "Devanga Chettiar",
      },
      {
        id: "887",
        caste: "Kuruhini Chetty",
      },
      {
        id: "888",
        caste: "Padmashali",
      },
      {
        id: "889",
        caste: "Pattusali",
      },
      {
        id: "890",
        caste: "Achirapakkam Chettiar",
      },
      {
        id: "891",
        caste: "Agaram Vellan Chettiar",
      },
      {
        id: "892",
        caste: "Ayira Vysya",
      },
      {
        id: "893",
        caste: "Beri Chettiar",
      },
      {
        id: "894",
        caste: "Elur Chetty",
      },
      {
        id: "895",
        caste: "Kasukara",
      },
      {
        id: "896",
        caste: "Kongu Chettiar",
      },
      {
        id: "897",
        caste: "Manjapudur Chettiar",
      },
      {
        id: "898",
        caste: "Nattukottai Chettiar",
      },
      {
        id: "899",
        caste: "Pannirandam Chettiar",
      },
      {
        id: "900",
        caste: "Sozhia Chetty",
      },
      {
        id: "901",
        caste: "Vadambar",
      },
      {
        id: "902",
        caste: "Vaniya Chettiar",
      },
      {
        id: "903",
        caste: "Vellan Chettiars",
      },
      {
        id: "904",
        caste: "Gounder - Others",
      },
      {
        id: "923",
        caste: "Ayodhyavasi",
      },
      {
        id: "924",
        caste: "Chaturth",
      },
      {
        id: "925",
        caste: "Gulahre",
      },
      {
        id: "926",
        caste: "Mahor",
      },
      {
        id: "927",
        caste: "Mathur Vaishya",
      },
      {
        id: "928",
        caste: "Kapu Reddy",
      },
      {
        id: "929",
        caste: "Kshatriya Raju",
      },
      {
        id: "933",
        caste: "Parit",
      },
      {
        id: "934",
        caste: "Vani",
      },
      {
        id: "935",
        caste: "Agamudayar / Arcot / Thuluva Vellala",
      },
      {
        id: "936",
        caste: "Isai Vellalar",
      },
      {
        id: "937",
        caste: "Veerakodi Vellala",
      },
      {
        id: "938",
        caste: "Kerala Mudali",
      },
      {
        id: "939",
        caste: "Naicker - Others",
      },
      {
        id: "942",
        caste: "Brahmin - Shri Mali",
      },
      {
        id: "943",
        caste: "Brahmin - Bardai",
      },
      {
        id: "944",
        caste: "Brahmin - Bhargav",
      },
      {
        id: "945",
        caste: "Brahmin - Khadayata",
      },
      {
        id: "946",
        caste: "Brahmin - Mevada",
      },
      {
        id: "947",
        caste: "Brahmin - Rajgor",
      },
      {
        id: "948",
        caste: "Brahmin - Sarua",
      },
      {
        id: "949",
        caste: "Brahmin - Tapodhan",
      },
      {
        id: "950",
        caste: "Brahmin - Valam",
      },
      {
        id: "951",
        caste: "Brahmin - Zalora",
      },
      {
        id: "954",
        caste: "Swakula Saali",
      },
      {
        id: "955",
        caste: "Kaikaala",
      },
      {
        id: "956",
        caste: "Karakala Bhakthula",
      },
      {
        id: "957",
        caste: "Karni Bhakthula",
      },
      {
        id: "958",
        caste: "Kurni",
      },
      {
        id: "959",
        caste: "Neeli Saali",
      },
      {
        id: "960",
        caste: "Nessi",
      },
      {
        id: "961",
        caste: "Shettigar",
      },
      {
        id: "962",
        caste: "Brahmin - Panicker",
      },
      {
        id: "963",
        caste: "Aaru Nattu Vellala",
      },
      {
        id: "965",
        caste: "Cherakula Vellalar",
      },
      {
        id: "966",
        caste: "Illaththu Pillai",
      },
      {
        id: "968",
        caste: "Kodikal Pillai",
      },
      {
        id: "969",
        caste: "Nanjil Mudali",
      },
      {
        id: "970",
        caste: "Nankudi Vellalar",
      },
      {
        id: "971",
        caste: "Pandiya Vellalar",
      },
      {
        id: "973",
        caste: "Nanjil pillai",
      },
      {
        id: "974",
        caste: "Kumaoni Rajput",
      },
      {
        id: "975",
        caste: "Mair Rajput Swarnkar",
      },
      {
        id: "976",
        caste: "Paswan / Dusadh",
      },
      {
        id: "977",
        caste: "Ahirwar",
      },
      {
        id: "978",
        caste: "Bairwa",
      },
      {
        id: "979",
        caste: "Balai",
      },
      {
        id: "980",
        caste: "Dhanak",
      },
      {
        id: "981",
        caste: "Julaha",
      },
      {
        id: "982",
        caste: "Kanakkan Padanna",
      },
      {
        id: "983",
        caste: "Kandara",
      },
      {
        id: "984",
        caste: "Khatik",
      },
      {
        id: "985",
        caste: "Mannan / Velan / Vannan",
      },
      {
        id: "986",
        caste: "Meghwal",
      },
      {
        id: "987",
        caste: "Panan",
      },
      {
        id: "988",
        caste: "Paravan / Bharatar",
      },
      {
        id: "989",
        caste: "Poundra",
      },
      {
        id: "990",
        caste: "Pulaya / Cheruman",
      },
      {
        id: "991",
        caste: "Samagar",
      },
      {
        id: "992",
        caste: "Satnami",
      },
      {
        id: "993",
        caste: "Shilpkar",
      },
      {
        id: "994",
        caste: "Sonkar",
      },
      {
        id: "995",
        caste: "Thandan",
      },
      {
        id: "996",
        caste: "Vettuvan",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
      {
        id: "1007",
        caste: "Nanjil Nattu Vellalar",
      },
      {
        id: "1008",
        caste: "Nanjil Vellalar",
      },
      {
        id: "1009",
        caste: "Oraon",
      },
      {
        id: "1010",
        caste: "Arakh / Arakvanshiya",
      },
      {
        id: "1011",
        caste: "Poddar",
      },
      {
        id: "1012",
        caste: "Saiva Vellan chettiar",
      },
      {
        id: "1013",
        caste: "Gavandi",
      },
      {
        id: "1014",
        caste: "Bhulia / Meher",
      },
      {
        id: "1015",
        caste: "Valsad",
      },
      {
        id: "1016",
        caste: "Modh Ghanchi",
      },
      {
        id: "1023",
        caste: "Swarnakar",
      },
      {
        id: "1024",
        caste: "Gond",
      },
      {
        id: "1025",
        caste: "Aguri / Ugra Kshatriya",
      },
      {
        id: "1026",
        caste: "Charan",
      },
      {
        id: "1027",
        caste: "Shah",
      },
      {
        id: "1028",
        caste: "Brahmakshtriya",
      },
      {
        id: "1029",
        caste: "Matia Patel",
      },
      {
        id: "1030",
        caste: "Kadia",
      },
      {
        id: "1031",
        caste: "Bhil",
      },
      {
        id: "1034",
        caste: "Aheriya",
      },
      {
        id: "1035",
        caste: "Kansyakaar",
      },
      {
        id: "1038",
        caste: "Amma Kodava",
      },
      {
        id: "1040",
        caste: "Heggade",
      },
      {
        id: "1041",
        caste: "Kodava",
      },
      {
        id: "1042",
        caste: "Chakkala Nair",
      },
      {
        id: "1043",
        caste: "Vellala Pillai",
      },
      {
        id: "1044",
        caste: "Tharakan",
      },
      {
        id: "1045",
        caste: "Mannadiyar",
      },
      {
        id: "1046",
        caste: "Odan",
      },
      {
        id: "1047",
        caste: "Valar",
      },
      {
        id: "1048",
        caste: "Holar",
      },
      {
        id: "1050",
        caste: "Vadar",
      },
      {
        id: "1053",
        caste: "Niari",
      },
      {
        id: "1054",
        caste: "Raju / Kshatriya Raju",
      },
      {
        id: "1055",
        caste: "Gopal / Gopala",
      },
      {
        id: "1056",
        caste: "Laxminarayan gola",
      },
      {
        id: "1057",
        caste: "Radhi / Niari",
      },
      {
        id: "1061",
        caste: "Saliyar",
      },
      {
        id: "1062",
        caste: "Dasapalanjika / Kannada Saineegar",
      },
      {
        id: "1063",
        caste: "Tammali",
      },
      {
        id: "1064",
        caste: "Vanyakulakshatriya",
      },
      {
        id: "2312",
        caste: "Dhanuk",
      },
      {
        id: "2313",
        caste: "Bairagi",
      },
      {
        id: "2314",
        caste: "Baori",
      },
      {
        id: "2315",
        caste: "Bargi",
      },
      {
        id: "2316",
        caste: "Bavaria",
      },
      {
        id: "2317",
        caste: "Bazigar",
      },
      {
        id: "2318",
        caste: "Beldar",
      },
      {
        id: "2319",
        caste: "Bhand",
      },
      {
        id: "2320",
        caste: "Brahmin - Bagra",
      },
      {
        id: "2321",
        caste: "Brahmin - Baragaon",
      },
      {
        id: "2322",
        caste: "Brahmin - Bhojak",
      },
      {
        id: "2323",
        caste: "Brahmin - Chaubisa",
      },
      {
        id: "2324",
        caste: "Brahmin - Dakaut",
      },
      {
        id: "2325",
        caste: "Dhakad",
      },
      {
        id: "2326",
        caste: "Dhanka",
      },
      {
        id: "2327",
        caste: "Garo / Garoda",
      },
      {
        id: "2328",
        caste: "Gavaria",
      },
      {
        id: "2329",
        caste: "Jingar",
      },
      {
        id: "2330",
        caste: "Kalbelia",
      },
      {
        id: "2331",
        caste: "Kandera",
      },
      {
        id: "2332",
        caste: "Kanjar",
      },
      {
        id: "2333",
        caste: "Kokna",
      },
      {
        id: "2334",
        caste: "Mehar",
      },
      {
        id: "2335",
        caste: "Nat",
      },
      {
        id: "2336",
        caste: "Rabari",
      },
      {
        id: "2337",
        caste: "Ravana Rajput",
      },
      {
        id: "2338",
        caste: "Sahariya",
      },
      {
        id: "2339",
        caste: "Salvi",
      },
      {
        id: "2340",
        caste: "Sansi",
      },
      {
        id: "2341",
        caste: "Sargara",
      },
      {
        id: "2342",
        caste: "Sirvi / Janwa",
      },
      {
        id: "2343",
        caste: "Sondhia",
      },
      {
        id: "2344",
        caste: "Bhar",
      },
      {
        id: "2345",
        caste: "Bharbhunja",
      },
      {
        id: "2346",
        caste: "Bind",
      },
      {
        id: "2347",
        caste: "Chero",
      },
      {
        id: "2348",
        caste: "Gandharb",
      },
      {
        id: "2349",
        caste: "Musahar",
      },
      {
        id: "2350",
        caste: "Tiyar/Tiar",
      },
      {
        id: "2376",
        caste: "Kasera",
      },
      {
        id: "2377",
        caste: "Lakhara / Lakhera / Laxkar",
      },
    ],
  },
  {
    id: "2",
    name: "Muslim",
    castealias: "Sect",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "400",
        caste: "Muslim - Ansari",
      },
      {
        id: "401",
        caste: "Muslim - Arain",
      },
      {
        id: "402",
        caste: "Muslim - Awan",
      },
      {
        id: "403",
        caste: "Muslim - Bohra",
      },
      {
        id: "404",
        caste: "Muslim - Dekkani",
      },
      {
        id: "405",
        caste: "Muslim - Dudekula",
      },
      {
        id: "406",
        caste: "Muslim - Hanafi",
      },
      {
        id: "407",
        caste: "Muslim - Jat",
      },
      {
        id: "408",
        caste: "Muslim - Khoja",
      },
      {
        id: "409",
        caste: "Muslim - Lebbai",
      },
      {
        id: "410",
        caste: "Muslim - Malik",
      },
      {
        id: "411",
        caste: "Muslim - Mapila",
      },
      {
        id: "412",
        caste: "Muslim - Maraicar",
      },
      {
        id: "413",
        caste: "Muslim - Memon",
      },
      {
        id: "414",
        caste: "Muslim - Mughal",
      },
      {
        id: "415",
        caste: "Muslim - Pathan",
      },
      {
        id: "416",
        caste: "Muslim - Qureshi",
      },
      {
        id: "417",
        caste: "Muslim - Rajput",
      },
      {
        id: "418",
        caste: "Muslim - Rowther",
      },
      {
        id: "419",
        caste: "Muslim - Shafi",
      },
      {
        id: "420",
        caste: "Muslim - Sheikh",
      },
      {
        id: "421",
        caste: "Muslim - Siddiqui",
      },
      {
        id: "422",
        caste: "Muslim - Syed",
      },
      {
        id: "423",
        caste: "Muslim - UnSpecified",
      },
      {
        id: "424",
        caste: "Muslim - Others",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "3",
    name: "Muslim - Shia",
    castealias: "Sect",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "400",
        caste: "Muslim - Ansari",
      },
      {
        id: "401",
        caste: "Muslim - Arain",
      },
      {
        id: "402",
        caste: "Muslim - Awan",
      },
      {
        id: "403",
        caste: "Muslim - Bohra",
      },
      {
        id: "404",
        caste: "Muslim - Dekkani",
      },
      {
        id: "405",
        caste: "Muslim - Dudekula",
      },
      {
        id: "406",
        caste: "Muslim - Hanafi",
      },
      {
        id: "407",
        caste: "Muslim - Jat",
      },
      {
        id: "408",
        caste: "Muslim - Khoja",
      },
      {
        id: "409",
        caste: "Muslim - Lebbai",
      },
      {
        id: "410",
        caste: "Muslim - Malik",
      },
      {
        id: "411",
        caste: "Muslim - Mapila",
      },
      {
        id: "412",
        caste: "Muslim - Maraicar",
      },
      {
        id: "413",
        caste: "Muslim - Memon",
      },
      {
        id: "414",
        caste: "Muslim - Mughal",
      },
      {
        id: "415",
        caste: "Muslim - Pathan",
      },
      {
        id: "416",
        caste: "Muslim - Qureshi",
      },
      {
        id: "417",
        caste: "Muslim - Rajput",
      },
      {
        id: "418",
        caste: "Muslim - Rowther",
      },
      {
        id: "419",
        caste: "Muslim - Shafi",
      },
      {
        id: "420",
        caste: "Muslim - Sheikh",
      },
      {
        id: "421",
        caste: "Muslim - Siddiqui",
      },
      {
        id: "422",
        caste: "Muslim - Syed",
      },
      {
        id: "423",
        caste: "Muslim - UnSpecified",
      },
      {
        id: "424",
        caste: "Muslim - Others",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "4",
    name: "Muslim - Sunni",
    castealias: "Sect",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "400",
        caste: "Muslim - Ansari",
      },
      {
        id: "401",
        caste: "Muslim - Arain",
      },
      {
        id: "402",
        caste: "Muslim - Awan",
      },
      {
        id: "403",
        caste: "Muslim - Bohra",
      },
      {
        id: "404",
        caste: "Muslim - Dekkani",
      },
      {
        id: "405",
        caste: "Muslim - Dudekula",
      },
      {
        id: "406",
        caste: "Muslim - Hanafi",
      },
      {
        id: "407",
        caste: "Muslim - Jat",
      },
      {
        id: "408",
        caste: "Muslim - Khoja",
      },
      {
        id: "409",
        caste: "Muslim - Lebbai",
      },
      {
        id: "410",
        caste: "Muslim - Malik",
      },
      {
        id: "411",
        caste: "Muslim - Mapila",
      },
      {
        id: "412",
        caste: "Muslim - Maraicar",
      },
      {
        id: "413",
        caste: "Muslim - Memon",
      },
      {
        id: "414",
        caste: "Muslim - Mughal",
      },
      {
        id: "415",
        caste: "Muslim - Pathan",
      },
      {
        id: "416",
        caste: "Muslim - Qureshi",
      },
      {
        id: "417",
        caste: "Muslim - Rajput",
      },
      {
        id: "418",
        caste: "Muslim - Rowther",
      },
      {
        id: "419",
        caste: "Muslim - Shafi",
      },
      {
        id: "420",
        caste: "Muslim - Sheikh",
      },
      {
        id: "421",
        caste: "Muslim - Siddiqui",
      },
      {
        id: "422",
        caste: "Muslim - Syed",
      },
      {
        id: "423",
        caste: "Muslim - UnSpecified",
      },
      {
        id: "424",
        caste: "Muslim - Others",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "6",
    name: "Christian",
    castealias: "Denomination",
    castes: [
      {
        id: "501",
        caste: "Born Again",
      },
      {
        id: "502",
        caste: "Brethren",
      },
      {
        id: "503",
        caste: "Church of South India",
      },
      {
        id: "504",
        caste: "Evangelist",
      },
      {
        id: "505",
        caste: "Jacobite",
      },
      {
        id: "506",
        caste: "Knanaya",
      },
      {
        id: "507",
        caste: "Knanaya Catholic",
      },
      {
        id: "508",
        caste: "Knanaya Jacobite",
      },
      {
        id: "509",
        caste: "Latin Catholic",
      },
      {
        id: "510",
        caste: "Malankara Catholic",
      },
      {
        id: "511",
        caste: "Marthoma",
      },
      {
        id: "512",
        caste: "Christian - Others",
      },
      {
        id: "513",
        caste: "Pentecost",
      },
      {
        id: "514",
        caste: "Roman Catholic",
      },
      {
        id: "515",
        caste: "Syrian Catholic",
      },
      {
        id: "516",
        caste: "Syrian Jacobite",
      },
      {
        id: "517",
        caste: "Syrian Orthodox",
      },
      {
        id: "518",
        caste: "Syro Malabar",
      },
      {
        id: "519",
        caste: "Don't wish to specify",
      },
      {
        id: "521",
        caste: "Seventh-day Adventist",
      },
      {
        id: "1017",
        caste: "Anglo-Indian",
      },
      {
        id: "1065",
        caste: "Protestant",
      },
      {
        id: "1066",
        caste: "Assembly of God (AG)",
      },
      {
        id: "1067",
        caste: "Church of God",
      },
      {
        id: "1068",
        caste: "Baptist",
      },
      {
        id: "1069",
        caste: "Adventist",
      },
      {
        id: "1070",
        caste: "Anglican / Episcopal",
      },
      {
        id: "1071",
        caste: "Jehovah's Witnesses",
      },
      {
        id: "1072",
        caste: "Methodist",
      },
      {
        id: "1073",
        caste: "Chaldean Syrian (Assyrian)",
      },
      {
        id: "1074",
        caste: "Lutheran",
      },
      {
        id: "1075",
        caste: "Mennonite",
      },
      {
        id: "1076",
        caste: "Calvinist",
      },
      {
        id: "1077",
        caste: "Congregational",
      },
      {
        id: "1078",
        caste: "Presbyterian",
      },
      {
        id: "1079",
        caste: "Latter day saints",
      },
      {
        id: "1080",
        caste: "Apostolic",
      },
      {
        id: "1081",
        caste: "Church of Christ",
      },
      {
        id: "1082",
        caste: "Church of North India",
      },
      {
        id: "1083",
        caste: "Melkite",
      },
      {
        id: "1084",
        caste: "Moravian",
      },
      {
        id: "1085",
        caste: "Orthodox",
      },
      {
        id: "1086",
        caste: "Malabar Independent Syrian Church",
      },
      {
        id: "1087",
        caste: "St. Thomas Evangelical",
      },
      {
        id: "1088",
        caste: "Reformed Baptist",
      },
      {
        id: "1089",
        caste: "Reformed Presbyterian",
      },
    ],
  },
  {
    id: "7",
    name: "Sikh",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "651",
        caste: "Sikh - Ahluwalia",
      },
      {
        id: "652",
        caste: "Sikh - Arora",
      },
      {
        id: "653",
        caste: "Sikh - Bhatia",
      },
      {
        id: "654",
        caste: "Sikh - Ghumar",
      },
      {
        id: "655",
        caste: "Sikh - Intercaste",
      },
      {
        id: "656",
        caste: "Sikh - Jat",
      },
      {
        id: "657",
        caste: "Sikh - Kamboj",
      },
      {
        id: "658",
        caste: "Sikh - Khatri",
      },
      {
        id: "659",
        caste: "Sikh - Kshatriya",
      },
      {
        id: "660",
        caste: "Sikh - Lubana",
      },
      {
        id: "661",
        caste: "Sikh - Majabi",
      },
      {
        id: "663",
        caste: "Sikh - Others",
      },
      {
        id: "664",
        caste: "Sikh - Rajput",
      },
      {
        id: "665",
        caste: "Sikh - Ramdasia",
      },
      {
        id: "666",
        caste: "Sikh - Ramgharia",
      },
      {
        id: "667",
        caste: "Sikh - Saini",
      },
      {
        id: "668",
        caste: "Sikh - Unspecified",
      },
      {
        id: "669",
        caste: "Sikh - Ravidasia",
      },
      {
        id: "670",
        caste: "Sikh - Bhatra",
      },
      {
        id: "671",
        caste: "Sikh - Tonk Kshatriya",
      },
      {
        id: "672",
        caste: "Sikh - Nai",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
      {
        id: "1018",
        caste: "Sikh - Rai",
      },
    ],
  },
  {
    id: "8",
    name: "Jain - All",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "601",
        caste: "Jain - Agarwal",
      },
      {
        id: "602",
        caste: "Jain - Bania",
      },
      {
        id: "603",
        caste: "Jain - Intercaste",
      },
      {
        id: "604",
        caste: "Jain - Jaiswal",
      },
      {
        id: "605",
        caste: "Jain - Khandelwal",
      },
      {
        id: "606",
        caste: "Jain - Kutchi",
      },
      {
        id: "608",
        caste: "Jain - Oswal",
      },
      {
        id: "609",
        caste: "Jain - Others",
      },
      {
        id: "610",
        caste: "Jain - Porwal",
      },
      {
        id: "611",
        caste: "Jain - Unspecified",
      },
      {
        id: "612",
        caste: "Jain - Vaishya",
      },
      {
        id: "613",
        caste: "Jain - KVO",
      },
      {
        id: "614",
        caste: "Jain - Asati",
      },
      {
        id: "615",
        caste: "Jain - Ayodhyavasi",
      },
      {
        id: "616",
        caste: "Jain - Bagherwal",
      },
      {
        id: "617",
        caste: "Jain - Barhiya",
      },
      {
        id: "618",
        caste: "Jain - Charanagare",
      },
      {
        id: "619",
        caste: "Jain - Chaturtha",
      },
      {
        id: "620",
        caste: "Jain - Dhakada",
      },
      {
        id: "621",
        caste: "Jain - Gahoi / Grihapati",
      },
      {
        id: "622",
        caste: "Jain - Golalare / Kharaua",
      },
      {
        id: "623",
        caste: "Jain - Golapurva",
      },
      {
        id: "624",
        caste: "Jain - Golsinghare",
      },
      {
        id: "625",
        caste: "Jain - Harada",
      },
      {
        id: "626",
        caste: "Jain - Humad / Humbad",
      },
      {
        id: "627",
        caste: "Jain - Kambhoja",
      },
      {
        id: "628",
        caste: "Jain - Kasar",
      },
      {
        id: "629",
        caste: "Jain - Kathanere",
      },
      {
        id: "630",
        caste: "Jain - Kharaua",
      },
      {
        id: "631",
        caste: "Jain - Lamechu",
      },
      {
        id: "632",
        caste: "Jain - Nema",
      },
      {
        id: "633",
        caste: "Jain - Padmavati Porwal",
      },
      {
        id: "634",
        caste: "Jain - Palliwal",
      },
      {
        id: "635",
        caste: "Jain - Panchama",
      },
      {
        id: "636",
        caste: "Jain - Parmar",
      },
      {
        id: "637",
        caste: "Jain - Parwar / Paravara",
      },
      {
        id: "638",
        caste: "Jain - Porwad / Porwal",
      },
      {
        id: "639",
        caste: "Jain - Saitwal",
      },
      {
        id: "640",
        caste: "Jain - Samanar / Nayinar",
      },
      {
        id: "641",
        caste: "Jain - Samiya",
      },
      {
        id: "642",
        caste: "Jain - Sarak",
      },
      {
        id: "643",
        caste: "Jain - Shrimal",
      },
      {
        id: "644",
        caste: "Jain - Upadhyaya",
      },
      {
        id: "645",
        caste: "Jain - Veerwal",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "9",
    name: "Jain - Digambar",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "601",
        caste: "Jain - Agarwal",
      },
      {
        id: "602",
        caste: "Jain - Bania",
      },
      {
        id: "603",
        caste: "Jain - Intercaste",
      },
      {
        id: "604",
        caste: "Jain - Jaiswal",
      },
      {
        id: "605",
        caste: "Jain - Khandelwal",
      },
      {
        id: "606",
        caste: "Jain - Kutchi",
      },
      {
        id: "608",
        caste: "Jain - Oswal",
      },
      {
        id: "609",
        caste: "Jain - Others",
      },
      {
        id: "610",
        caste: "Jain - Porwal",
      },
      {
        id: "611",
        caste: "Jain - Unspecified",
      },
      {
        id: "612",
        caste: "Jain - Vaishya",
      },
      {
        id: "613",
        caste: "Jain - KVO",
      },
      {
        id: "614",
        caste: "Jain - Asati",
      },
      {
        id: "615",
        caste: "Jain - Ayodhyavasi",
      },
      {
        id: "616",
        caste: "Jain - Bagherwal",
      },
      {
        id: "617",
        caste: "Jain - Barhiya",
      },
      {
        id: "618",
        caste: "Jain - Charanagare",
      },
      {
        id: "619",
        caste: "Jain - Chaturtha",
      },
      {
        id: "620",
        caste: "Jain - Dhakada",
      },
      {
        id: "621",
        caste: "Jain - Gahoi / Grihapati",
      },
      {
        id: "622",
        caste: "Jain - Golalare / Kharaua",
      },
      {
        id: "623",
        caste: "Jain - Golapurva",
      },
      {
        id: "624",
        caste: "Jain - Golsinghare",
      },
      {
        id: "625",
        caste: "Jain - Harada",
      },
      {
        id: "626",
        caste: "Jain - Humad / Humbad",
      },
      {
        id: "627",
        caste: "Jain - Kambhoja",
      },
      {
        id: "628",
        caste: "Jain - Kasar",
      },
      {
        id: "629",
        caste: "Jain - Kathanere",
      },
      {
        id: "630",
        caste: "Jain - Kharaua",
      },
      {
        id: "631",
        caste: "Jain - Lamechu",
      },
      {
        id: "632",
        caste: "Jain - Nema",
      },
      {
        id: "633",
        caste: "Jain - Padmavati Porwal",
      },
      {
        id: "634",
        caste: "Jain - Palliwal",
      },
      {
        id: "635",
        caste: "Jain - Panchama",
      },
      {
        id: "636",
        caste: "Jain - Parmar",
      },
      {
        id: "637",
        caste: "Jain - Parwar / Paravara",
      },
      {
        id: "638",
        caste: "Jain - Porwad / Porwal",
      },
      {
        id: "639",
        caste: "Jain - Saitwal",
      },
      {
        id: "640",
        caste: "Jain - Samanar / Nayinar",
      },
      {
        id: "641",
        caste: "Jain - Samiya",
      },
      {
        id: "642",
        caste: "Jain - Sarak",
      },
      {
        id: "643",
        caste: "Jain - Shrimal",
      },
      {
        id: "644",
        caste: "Jain - Upadhyaya",
      },
      {
        id: "645",
        caste: "Jain - Veerwal",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "10",
    name: "Jain - Shwetambar",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "601",
        caste: "Jain - Agarwal",
      },
      {
        id: "602",
        caste: "Jain - Bania",
      },
      {
        id: "603",
        caste: "Jain - Intercaste",
      },
      {
        id: "604",
        caste: "Jain - Jaiswal",
      },
      {
        id: "605",
        caste: "Jain - Khandelwal",
      },
      {
        id: "606",
        caste: "Jain - Kutchi",
      },
      {
        id: "608",
        caste: "Jain - Oswal",
      },
      {
        id: "609",
        caste: "Jain - Others",
      },
      {
        id: "610",
        caste: "Jain - Porwal",
      },
      {
        id: "611",
        caste: "Jain - Unspecified",
      },
      {
        id: "612",
        caste: "Jain - Vaishya",
      },
      {
        id: "613",
        caste: "Jain - KVO",
      },
      {
        id: "614",
        caste: "Jain - Asati",
      },
      {
        id: "615",
        caste: "Jain - Ayodhyavasi",
      },
      {
        id: "616",
        caste: "Jain - Bagherwal",
      },
      {
        id: "617",
        caste: "Jain - Barhiya",
      },
      {
        id: "618",
        caste: "Jain - Charanagare",
      },
      {
        id: "619",
        caste: "Jain - Chaturtha",
      },
      {
        id: "620",
        caste: "Jain - Dhakada",
      },
      {
        id: "621",
        caste: "Jain - Gahoi / Grihapati",
      },
      {
        id: "622",
        caste: "Jain - Golalare / Kharaua",
      },
      {
        id: "623",
        caste: "Jain - Golapurva",
      },
      {
        id: "624",
        caste: "Jain - Golsinghare",
      },
      {
        id: "625",
        caste: "Jain - Harada",
      },
      {
        id: "626",
        caste: "Jain - Humad / Humbad",
      },
      {
        id: "627",
        caste: "Jain - Kambhoja",
      },
      {
        id: "628",
        caste: "Jain - Kasar",
      },
      {
        id: "629",
        caste: "Jain - Kathanere",
      },
      {
        id: "630",
        caste: "Jain - Kharaua",
      },
      {
        id: "631",
        caste: "Jain - Lamechu",
      },
      {
        id: "632",
        caste: "Jain - Nema",
      },
      {
        id: "633",
        caste: "Jain - Padmavati Porwal",
      },
      {
        id: "634",
        caste: "Jain - Palliwal",
      },
      {
        id: "635",
        caste: "Jain - Panchama",
      },
      {
        id: "636",
        caste: "Jain - Parmar",
      },
      {
        id: "637",
        caste: "Jain - Parwar / Paravara",
      },
      {
        id: "638",
        caste: "Jain - Porwad / Porwal",
      },
      {
        id: "639",
        caste: "Jain - Saitwal",
      },
      {
        id: "640",
        caste: "Jain - Samanar / Nayinar",
      },
      {
        id: "641",
        caste: "Jain - Samiya",
      },
      {
        id: "642",
        caste: "Jain - Sarak",
      },
      {
        id: "643",
        caste: "Jain - Shrimal",
      },
      {
        id: "644",
        caste: "Jain - Upadhyaya",
      },
      {
        id: "645",
        caste: "Jain - Veerwal",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "12",
    name: "Parsi",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "63",
        caste: "Intercaste",
      },
      {
        id: "64",
        caste: "Irani",
      },
      {
        id: "154",
        caste: "Parsi",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
    ],
  },
  {
    id: "13",
    name: "Buddhist",
    castealias: "Branch",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
      {
        id: "2309",
        caste: "Neo Buddhist",
      },
      {
        id: "2310",
        caste: "Tibetan Buddhist",
      },
      {
        id: "2311",
        caste: "Others",
      },
    ],
  },
  {
    id: "14",
    name: "Jewish",
    castealias: "Caste",
    castes: [
      { id: "0", caste: "Don't wish to specify" },
      { id: "999", caste: "Other Caste" },
    ],
  },
  {
    id: "15",
    name: "Inter-Religion",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        caste: "Don't wish to specify",
      },
      {
        id: "1",
        caste: "Ad Dharmi",
      },
      {
        id: "2",
        caste: "Adi Dravidar",
      },
      {
        id: "3",
        caste: "Agarwal",
      },
      {
        id: "4",
        caste: "Agnikula Kshatriya",
      },
      {
        id: "5",
        caste: "Agri",
      },
      {
        id: "6",
        caste: "Ahom",
      },
      {
        id: "7",
        caste: "Ambalavasi",
      },
      {
        id: "8",
        caste: "Arunthathiyar",
      },
      {
        id: "9",
        caste: "Arya Vysya",
      },
      {
        id: "10",
        caste: "Baidya",
      },
      {
        id: "11",
        caste: "Baishnab",
      },
      {
        id: "12",
        caste: "Baishya",
      },
      {
        id: "13",
        caste: "Balija",
      },
      {
        id: "14",
        caste: "Banik",
      },
      {
        id: "15",
        caste: "Baniya",
      },
      {
        id: "16",
        caste: "Barujibi",
      },
      {
        id: "17",
        caste: "Besta",
      },
      {
        id: "18",
        caste: "Bhandari",
      },
      {
        id: "19",
        caste: "Bhatia",
      },
      {
        id: "20",
        caste: "Bhavasar Kshatriya",
      },
      {
        id: "21",
        caste: "Bhovi",
      },
      {
        id: "22",
        caste: "Billava",
      },
      {
        id: "23",
        caste: "Boyar",
      },
      {
        id: "24",
        caste: "Brahmbatt",
      },
      {
        id: "25",
        caste: "Brahmin - Others",
      },
      {
        id: "26",
        caste: "Brahmin - Gurukkal",
      },
      {
        id: "26_ALT",
        caste: "Gurukkal Brahmin",
      },
      {
        id: "27",
        caste: "Brahmin - Iyengar",
      },
      {
        id: "27_ALT",
        caste: "Iyengar Brahmin",
      },
      {
        id: "28",
        caste: "Brahmin - Iyer",
      },
      {
        id: "28_ALT",
        caste: "Iyer Brahmin",
      },
      {
        id: "29",
        caste: "Jatav",
      },
      {
        id: "30",
        caste: "Chambhar",
      },
      {
        id: "31",
        caste: "Chandravanshi Kahar",
      },
      {
        id: "32",
        caste: "Chasa",
      },
      {
        id: "33",
        caste: "Chaudary",
      },
      {
        id: "34",
        caste: "Chaurasia",
      },
      {
        id: "35",
        caste: "Chettiar",
      },
      {
        id: "36",
        caste: "Chhetri",
      },
      {
        id: "37",
        caste: "CKP",
      },
      {
        id: "38",
        caste: "Coorgi",
      },
      {
        id: "39",
        caste: "Devadiga",
      },
      {
        id: "40",
        caste: "Devandra Kula Vellalar",
      },
      {
        id: "41",
        caste: "Devang Koshthi",
      },
      {
        id: "42",
        caste: "Devanga",
      },
      {
        id: "43",
        caste: "Dhangar",
      },
      {
        id: "44",
        caste: "Dheevara",
      },
      {
        id: "45",
        caste: "Dhiman",
      },
      {
        id: "46",
        caste: "Dhoba",
      },
      {
        id: "47",
        caste: "Madivala / Dhobi",
      },
      {
        id: "48",
        caste: "Ediga",
      },
      {
        id: "49",
        caste: "Ezhava",
      },
      {
        id: "50",
        caste: "Ezhuthachan",
      },
      {
        id: "51",
        caste: "Gabit",
      },
      {
        id: "52",
        caste: "Gandla",
      },
      {
        id: "53",
        caste: "Ganiga",
      },
      {
        id: "54",
        caste: "Garhwali",
      },
      {
        id: "55",
        caste: "Gavara",
      },
      {
        id: "56",
        caste: "Ghumar",
      },
      {
        id: "57",
        caste: "Goala",
      },
      {
        id: "58",
        caste: "Goan",
      },
      {
        id: "59",
        caste: "Gounder",
      },
      {
        id: "60",
        caste: "Gowda",
      },
      {
        id: "61",
        caste: "Gudia",
      },
      {
        id: "62",
        caste: "Gupta",
      },
      {
        id: "63",
        caste: "Intercaste",
      },
      {
        id: "64",
        caste: "Irani",
      },
      {
        id: "65",
        caste: "Jaiswal",
      },
      {
        id: "66",
        caste: "Jangam",
      },
      {
        id: "67",
        caste: "Jat",
      },
      {
        id: "68",
        caste: "Kaibarta",
      },
      {
        id: "69",
        caste: "Kalar",
      },
      {
        id: "70",
        caste: "Kalinga",
      },
      {
        id: "71",
        caste: "Kalita",
      },
      {
        id: "72",
        caste: "Kalwar",
      },
      {
        id: "73",
        caste: "Kamboj",
      },
      {
        id: "74",
        caste: "Kamma",
      },
      {
        id: "75",
        caste: "Kansari",
      },
      {
        id: "76",
        caste: "Kapu",
      },
      {
        id: "77",
        caste: "Karana",
      },
      {
        id: "78",
        caste: "Karmakar",
      },
      {
        id: "79",
        caste: "Karuneegar",
      },
      {
        id: "80",
        caste: "Kasar",
      },
      {
        id: "81",
        caste: "Kashyap",
      },
      {
        id: "82",
        caste: "Kayastha",
      },
      {
        id: "83",
        caste: "Khandayat",
      },
      {
        id: "84",
        caste: "Khandelwal",
      },
      {
        id: "85",
        caste: "Khatri",
      },
      {
        id: "86",
        caste: "Koli",
      },
      {
        id: "87",
        caste: "Kongu Vellala Gounder",
      },
      {
        id: "88",
        caste: "Konkani",
      },
      {
        id: "89",
        caste: "Kori",
      },
      {
        id: "90",
        caste: "Kshatriya",
      },
      {
        id: "91",
        caste: "Kudumbi",
      },
      {
        id: "92",
        caste: "Kulal",
      },
      {
        id: "93",
        caste: "Kulalar",
      },
      {
        id: "94",
        caste: "Kulita",
      },
      {
        id: "95",
        caste: "Kumbhakar",
      },
      {
        id: "96",
        caste: "Kumbhar",
      },
      {
        id: "97",
        caste: "Kumhar",
      },
      {
        id: "98",
        caste: "Kummari",
      },
      {
        id: "99",
        caste: "Kunbi",
      },
      {
        id: "100",
        caste: "Kurmi/Kurmi Kshatriya",
      },
      {
        id: "101",
        caste: "Kuruba",
      },
      {
        id: "102",
        caste: "Kuruhina Shetty",
      },
      {
        id: "103",
        caste: "Kurumbar",
      },
      {
        id: "104",
        caste: "Kutchi",
      },
      {
        id: "105",
        caste: "Lambadi",
      },
      {
        id: "106",
        caste: "Lingayath",
      },
      {
        id: "107",
        caste: "Lohana",
      },
      {
        id: "108",
        caste: "Lubana",
      },
      {
        id: "109",
        caste: "Madiga",
      },
      {
        id: "110",
        caste: "Mahajan",
      },
      {
        id: "111",
        caste: "Mahar",
      },
      {
        id: "112",
        caste: "Mahendra",
      },
      {
        id: "113",
        caste: "Maheshwari",
      },
      {
        id: "114",
        caste: "Mahishya",
      },
      {
        id: "115",
        caste: "Majabi",
      },
      {
        id: "116",
        caste: "Mala",
      },
      {
        id: "117",
        caste: "Mali",
      },
      {
        id: "118",
        caste: "Mallah",
      },
      {
        id: "119",
        caste: "Mangalorean",
      },
      {
        id: "120",
        caste: "Manipuri",
      },
      {
        id: "121",
        caste: "Munnuru Kapu",
      },
      {
        id: "122",
        caste: "Mapila",
      },
      {
        id: "123",
        caste: "Maratha",
      },
      {
        id: "124",
        caste: "Maruthuvar",
      },
      {
        id: "125",
        caste: "Matang",
      },
      {
        id: "126",
        caste: "Meena",
      },
      {
        id: "127",
        caste: "Meenavar",
      },
      {
        id: "128",
        caste: "Mehra",
      },
      {
        id: "129",
        caste: "Meru Darji",
      },
      {
        id: "129_ALT",
        caste: "Darji",
      },
      {
        id: "130",
        caste: "Mochi",
      },
      {
        id: "131",
        caste: "Modak",
      },
      {
        id: "132",
        caste: "Mogaveera",
      },
      {
        id: "133",
        caste: "Mudaliyar",
      },
      {
        id: "134",
        caste: "Mudiraj",
      },
      {
        id: "135",
        caste: "Devar/Thevar/Mukkulathor",
      },
      {
        id: "135_ALT",
        caste: "Mukkulathor",
      },
      {
        id: "136",
        caste: "Muthuraja / Mutharaiyar",
      },
      {
        id: "137",
        caste: "Nadar",
      },
      {
        id: "138",
        caste: "Nai / Nayi Brahmin",
      },
      {
        id: "139",
        caste: "Naicker",
      },
      {
        id: "140",
        caste: "Naidu",
      },
      {
        id: "141",
        caste: "Naik",
      },
      {
        id: "142",
        caste: "Nair",
      },
      {
        id: "143",
        caste: "Namasudra / Namassej",
      },
      {
        id: "144",
        caste: "Napit",
      },
      {
        id: "145",
        caste: "Nayaka",
      },
      {
        id: "146",
        caste: "Nepali",
      },
      {
        id: "147",
        caste: "Nhavi",
      },
      {
        id: "148",
        caste: "Oswal",
      },
      {
        id: "149",
        caste: "Padmasali",
      },
      {
        id: "150",
        caste: "Pal",
      },
      {
        id: "151",
        caste: "Panchal",
      },
      {
        id: "152",
        caste: "Panicker",
      },
      {
        id: "153",
        caste: "Parkavakulam / Udayar",
      },
      {
        id: "154",
        caste: "Parsi",
      },
      {
        id: "155",
        caste: "Pasi",
      },
      {
        id: "156",
        caste: "Patel",
      },
      {
        id: "157",
        caste: "Patnaick/Sistakaranam",
      },
      {
        id: "158",
        caste: "Patra",
      },
      {
        id: "159",
        caste: "Pillai",
      },
      {
        id: "160",
        caste: "Porwal",
      },
      {
        id: "161",
        caste: "Prajapati",
      },
      {
        id: "162",
        caste: "Rajaka / Vannar",
      },
      {
        id: "163",
        caste: "Rajastani",
      },
      {
        id: "164",
        caste: "Rajbonshi",
      },
      {
        id: "165",
        caste: "Rajput",
      },
      {
        id: "166",
        caste: "Ramdasia",
      },
      {
        id: "167",
        caste: "Ramgariah",
      },
      {
        id: "168",
        caste: "Ravidasia",
      },
      {
        id: "169",
        caste: "Rawat",
      },
      {
        id: "170",
        caste: "Reddy",
      },
      {
        id: "171",
        caste: "Sadgope",
      },
      {
        id: "172",
        caste: "Saha",
      },
      {
        id: "173",
        caste: "Sahu",
      },
      {
        id: "174",
        caste: "Saini",
      },
      {
        id: "175",
        caste: "Saliya",
      },
      {
        id: "176",
        caste: "SC",
      },
      {
        id: "177",
        caste: "Senai Thalaivar",
      },
      {
        id: "178",
        caste: "Bunt (Shetty)",
      },
      {
        id: "178_ALT",
        caste: "Shetty",
      },
      {
        id: "179",
        caste: "Shimpi/Namdev",
      },
      {
        id: "180",
        caste: "Sindhi",
      },
      {
        id: "181",
        caste: "Sindhi-Amil",
      },
      {
        id: "181_ALT",
        caste: "Amil Sindhi",
      },
      {
        id: "182",
        caste: "Sindhi-Baibhand",
      },
      {
        id: "182_ALT",
        caste: "Baibhand Sindhi",
      },
      {
        id: "183",
        caste: "Sindhi-Bhanusali",
      },
      {
        id: "183_ALT",
        caste: "Bhanusali Sindhi",
      },
      {
        id: "184",
        caste: "Sindhi-Bhatia",
      },
      {
        id: "184_ALT",
        caste: "Bhatia Sindhi",
      },
      {
        id: "185",
        caste: "Sindhi-Chhapru",
      },
      {
        id: "185_ALT",
        caste: "Chhapru Sindhi",
      },
      {
        id: "186",
        caste: "Sindhi-Dadu",
      },
      {
        id: "186_ALT",
        caste: "Dadu Sindhi",
      },
      {
        id: "187",
        caste: "Sindhi-Hyderabadi",
      },
      {
        id: "187_ALT",
        caste: "Hyderabadi Sindhi",
      },
      {
        id: "188",
        caste: "Sindhi-Larai",
      },
      {
        id: "188_ALT",
        caste: "Larai Sindhi",
      },
      {
        id: "189",
        caste: "Sindhi-Larkana",
      },
      {
        id: "189_ALT",
        caste: "Larkana Sindhi",
      },
      {
        id: "190",
        caste: "Sindhi-Lohana",
      },
      {
        id: "190_ALT",
        caste: "Lohana Sindhi",
      },
      {
        id: "191",
        caste: "Sindhi-Rohiri",
      },
      {
        id: "191_ALT",
        caste: "Rohiri Sindhi",
      },
      {
        id: "192",
        caste: "Sindhi-Sahiti",
      },
      {
        id: "192_ALT",
        caste: "Sahiti Sindhi",
      },
      {
        id: "193",
        caste: "Sindhi-Sakkhar",
      },
      {
        id: "193_ALT",
        caste: "Sakkhar Sindhi",
      },
      {
        id: "194",
        caste: "Sindhi-Sehwani",
      },
      {
        id: "194_ALT",
        caste: "Sehwani Sindhi",
      },
      {
        id: "195",
        caste: "Sindhi-Shikarpuri",
      },
      {
        id: "195_ALT",
        caste: "Shikarpuri Sindhi",
      },
      {
        id: "196",
        caste: "Sindhi-Thatai",
      },
      {
        id: "196_ALT",
        caste: "Thatai Sindhi",
      },
      {
        id: "197",
        caste: "SKP",
      },
      {
        id: "198",
        caste: "Sonar",
      },
      {
        id: "199",
        caste: "Soni",
      },
      {
        id: "200",
        caste: "Sourashtra",
      },
      {
        id: "201",
        caste: "Sundhi",
      },
      {
        id: "202",
        caste: "Suthar",
      },
      {
        id: "203",
        caste: "Swakula Sali",
      },
      {
        id: "204",
        caste: "Tamboli",
      },
      {
        id: "205",
        caste: "Tanti",
      },
      {
        id: "206",
        caste: "Tantubai",
      },
      {
        id: "207",
        caste: "Telaga",
      },
      {
        id: "208",
        caste: "Teli",
      },
      {
        id: "209",
        caste: "Thakkar",
      },
      {
        id: "210",
        caste: "Thakur",
      },
      {
        id: "211",
        caste: "Thigala",
      },
      {
        id: "212",
        caste: "Thiyya",
      },
      {
        id: "213",
        caste: "Tili",
      },
      {
        id: "214",
        caste: "ST",
      },
      {
        id: "215",
        caste: "Sagara (Uppara)",
      },
      {
        id: "216",
        caste: "Vaddera",
      },
      {
        id: "217",
        caste: "Vaish",
      },
      {
        id: "218",
        caste: "Vaishnav",
      },
      {
        id: "219",
        caste: "Vaishnava",
      },
      {
        id: "220",
        caste: "Vaishya",
      },
      {
        id: "221",
        caste: "Vaishya Vani",
      },
      {
        id: "222",
        caste: "Valmiki",
      },
      {
        id: "223",
        caste: "Vania",
      },
      {
        id: "224",
        caste: "Vaniya",
      },
      {
        id: "225",
        caste: "Vanjara",
      },
      {
        id: "226",
        caste: "Vanjari",
      },
      {
        id: "227",
        caste: "Vankar",
      },
      {
        id: "228",
        caste: "Vannar",
      },
      {
        id: "229",
        caste: "Vannia Kula Kshatriyar",
      },
      {
        id: "230",
        caste: "Veera Saivam",
      },
      {
        id: "231",
        caste: "Velama",
      },
      {
        id: "232",
        caste: "Vellalar",
      },
      {
        id: "233",
        caste: "Veluthedathu Nair",
      },
      {
        id: "234",
        caste: "Vilakkithala Nair",
      },
      {
        id: "235",
        caste: "Viswabrahmin",
      },
      {
        id: "236",
        caste: "Vishwakarma",
      },
      {
        id: "237",
        caste: "Vokkaliga",
      },
      {
        id: "238",
        caste: "Vysya",
      },
      {
        id: "239",
        caste: "Yadav",
      },
      {
        id: "240",
        caste: "Brahmin - Bhumihar",
      },
      {
        id: "240_ALT",
        caste: "Bhumihar Brahmin",
      },
      {
        id: "241",
        caste: "Brahmin - Kanyakubj",
      },
      {
        id: "241_ALT",
        caste: "Kanyakubj Brahmin",
      },
      {
        id: "242",
        caste: "Brahmin - Gaur",
      },
      {
        id: "242_ALT",
        caste: "Gaur Brahmin",
      },
      {
        id: "243",
        caste: "Brahmin - Maithil",
      },
      {
        id: "243_ALT",
        caste: "Maithil Brahmin",
      },
      {
        id: "244",
        caste: "Brahmin - Saryuparin",
      },
      {
        id: "244_ALT",
        caste: "Saryuparin Brahmin",
      },
      {
        id: "245",
        caste: "Brahmin - Garhwali",
      },
      {
        id: "245_ALT",
        caste: "Garhwali Brahmin",
      },
      {
        id: "246",
        caste: "Brahmin - Pandit",
      },
      {
        id: "246_ALT",
        caste: "Pandit Brahmin",
      },
      {
        id: "247",
        caste: "Brahmin - Sanadya",
      },
      {
        id: "247_ALT",
        caste: "Sanadya Brahmin",
      },
      {
        id: "248",
        caste: "Brahmin - Kumaoni",
      },
      {
        id: "248_ALT",
        caste: "Kumaoni Brahmin",
      },
      {
        id: "249",
        caste: "Brahmin - Tyagi",
      },
      {
        id: "249_ALT",
        caste: "Tyagi Brahmin",
      },
      {
        id: "250",
        caste: "Goud",
      },
      {
        id: "251",
        caste: "Kadava Patel",
      },
      {
        id: "252",
        caste: "Leva patel",
      },
      {
        id: "253",
        caste: "Leva patil",
      },
      {
        id: "254",
        caste: "Brahmin - Barendra",
      },
      {
        id: "254_ALT",
        caste: "Barendra Brahmin",
      },
      {
        id: "255",
        caste: "Brahmin - Kulin",
      },
      {
        id: "255_ALT",
        caste: "Kulin Brahmin",
      },
      {
        id: "256",
        caste: "Brahmin - Rarhi",
      },
      {
        id: "256_ALT",
        caste: "Rarhi Brahmin",
      },
      {
        id: "257",
        caste: "Brahmin - Rudraj",
      },
      {
        id: "257_ALT",
        caste: "Rudraj Brahmin",
      },
      {
        id: "258",
        caste: "Brahmin - Namboodiri",
      },
      {
        id: "258_ALT",
        caste: "Namboodiri Brahmin",
      },
      {
        id: "259",
        caste: "Brahmin - Saraswat",
      },
      {
        id: "259_ALT",
        caste: "Saraswat Brahmin",
      },
      {
        id: "260",
        caste: "Brahmin - Anavil",
      },
      {
        id: "260_ALT",
        caste: "Anavil Brahmin",
      },
      {
        id: "261",
        caste: "Brahmin - Audichya",
      },
      {
        id: "261_ALT",
        caste: "Audichya Brahmin",
      },
      {
        id: "262",
        caste: "Brahmin - Goswami/Gosavi",
      },
      {
        id: "262_ALT",
        caste: "Goswami/Gosavi Brahmin",
      },
      {
        id: "263",
        caste: "Brahmin - Modh",
      },
      {
        id: "263_ALT",
        caste: "Modh Brahmin",
      },
      {
        id: "264",
        caste: "Brahmin - Nagar",
      },
      {
        id: "264_ALT",
        caste: "Nagar Brahmin",
      },
      {
        id: "265",
        caste: "Brahmin - Shrimali",
      },
      {
        id: "265_ALT",
        caste: "Shrimali Brahmin",
      },
      {
        id: "266",
        caste: "Brahmin - Vyas",
      },
      {
        id: "266_ALT",
        caste: "Vyas Brahmin",
      },
      {
        id: "267",
        caste: "Brahmin - Bhatt",
      },
      {
        id: "267_ALT",
        caste: "Bhatt Brahmin",
      },
      {
        id: "268",
        caste: "Brahmin - Sakaldwipi",
      },
      {
        id: "268_ALT",
        caste: "Sakaldwipi Brahmin",
      },
      {
        id: "269",
        caste: "Brahmin - Daivadnya",
      },
      {
        id: "269_ALT",
        caste: "Daivadnya Brahmin",
      },
      {
        id: "270",
        caste: "Brahmin - Deshastha",
      },
      {
        id: "270_ALT",
        caste: "Deshastha Brahmin",
      },
      {
        id: "271",
        caste: "Brahmin - Havyaka",
      },
      {
        id: "271_ALT",
        caste: "Havyaka Brahmin",
      },
      {
        id: "272",
        caste: "Brahmin - Hoysala",
      },
      {
        id: "272_ALT",
        caste: "Hoysala Brahmin",
      },
      {
        id: "273",
        caste: "Brahmin - Karhade",
      },
      {
        id: "273_ALT",
        caste: "Karhade Brahmin",
      },
      {
        id: "274",
        caste: "Brahmin - Kota",
      },
      {
        id: "274_ALT",
        caste: "Kota Brahmin",
      },
      {
        id: "275",
        caste: "Brahmin - Madhwa",
      },
      {
        id: "275_ALT",
        caste: "Madhwa Brahmin",
      },
      {
        id: "276",
        caste: "Brahmin - Sanketi",
      },
      {
        id: "276_ALT",
        caste: "Sanketi Brahmin",
      },
      {
        id: "277",
        caste: "Brahmin - Shivhalli",
      },
      {
        id: "277_ALT",
        caste: "Shivhalli Brahmin",
      },
      {
        id: "278",
        caste: "Brahmin - Smartha",
      },
      {
        id: "278_ALT",
        caste: "Smartha Brahmin",
      },
      {
        id: "279",
        caste: "Brahmin - Sri Vaishnava",
      },
      {
        id: "279_ALT",
        caste: "Sri Vaishnava Brahmin",
      },
      {
        id: "280",
        caste: "Brahmin - Stanika",
      },
      {
        id: "280_ALT",
        caste: "Stanika Brahmin",
      },
      {
        id: "281",
        caste: "Arora",
      },
      {
        id: "282",
        caste: "Brahmin - Mohyal",
      },
      {
        id: "282_ALT",
        caste: "Mohyal Brahmin",
      },
      {
        id: "283",
        caste: "Brahmin - Kokanastha",
      },
      {
        id: "283_ALT",
        caste: "Kokanastha Brahmin",
      },
      {
        id: "284",
        caste: "Brahmin - Rigvedi",
      },
      {
        id: "284_ALT",
        caste: "Rigvedi Brahmin",
      },
      {
        id: "285",
        caste: "Brahmin - Vaidiki",
      },
      {
        id: "285_ALT",
        caste: "Vaidiki Brahmin",
      },
      {
        id: "286",
        caste: "Brahmin - Danua",
      },
      {
        id: "286_ALT",
        caste: "Danua Brahmin",
      },
      {
        id: "287",
        caste: "Brahmin - Halua",
      },
      {
        id: "287_ALT",
        caste: "Halua Brahmin",
      },
      {
        id: "288",
        caste: "Brahmin - Jhadua",
      },
      {
        id: "288_ALT",
        caste: "Jhadua Brahmin",
      },
      {
        id: "289",
        caste: "Brahmin - Panda",
      },
      {
        id: "289_ALT",
        caste: "Panda Brahmin",
      },
      {
        id: "290",
        caste: "Brahmin - Dhiman",
      },
      {
        id: "290_ALT",
        caste: "Dhiman Brahmin",
      },
      {
        id: "291",
        caste: "Brahmin - Dravida",
      },
      {
        id: "291_ALT",
        caste: "Dravida Brahmin",
      },
      {
        id: "292",
        caste: "Brahmin - Niyogi",
      },
      {
        id: "292_ALT",
        caste: "Niyogi Brahmin",
      },
      {
        id: "293",
        caste: "Settibalija",
      },
      {
        id: "294",
        caste: "Arekatica",
      },
      {
        id: "295",
        caste: "Banjara",
      },
      {
        id: "296",
        caste: "Barai",
      },
      {
        id: "297",
        caste: "Bari",
      },
      {
        id: "298",
        caste: "Bhatraju",
      },
      {
        id: "299",
        caste: "Brahmin - Jangid",
      },
      {
        id: "299_ALT",
        caste: "Jangid Brahmin",
      },
      {
        id: "301",
        caste: "Chippolu (Mera)",
      },
      {
        id: "301_ALT",
        caste: "Mera",
      },
      {
        id: "302",
        caste: "Dumal",
      },
      {
        id: "303",
        caste: "Dusadh (Paswan)",
      },
      {
        id: "303_ALT",
        caste: "Paswan",
      },
      {
        id: "304",
        caste: "Gawali",
      },
      {
        id: "305",
        caste: "Ghisadi",
      },
      {
        id: "306",
        caste: "Gomantak",
      },
      {
        id: "307",
        caste: "Gondhali",
      },
      {
        id: "308",
        caste: "Gramani",
      },
      {
        id: "309",
        caste: "Gurav",
      },
      {
        id: "310",
        caste: "Gujjar",
      },
      {
        id: "311",
        caste: "Guptan",
      },
      {
        id: "312",
        caste: "Gurjar",
      },
      {
        id: "313",
        caste: "Hugar (Jeer)",
      },
      {
        id: "313_ALT",
        caste: "Jeer",
      },
      {
        id: "314",
        caste: "Jaalari",
      },
      {
        id: "315",
        caste: "Jandra",
      },
      {
        id: "316",
        caste: "Jangra - Brahmin",
      },
      {
        id: "317",
        caste: "Jogi (Nath)",
      },
      {
        id: "317_ALT",
        caste: "Nath",
      },
      {
        id: "318",
        caste: "Kachara",
      },
      {
        id: "319",
        caste: "Kalinga Vysya",
      },
      {
        id: "320",
        caste: "Katiya",
      },
      {
        id: "321",
        caste: "Kharwar",
      },
      {
        id: "322",
        caste: "Kokanastha Maratha",
      },
      {
        id: "323",
        caste: "Kumawat",
      },
      {
        id: "324",
        caste: "Kuravan",
      },
      {
        id: "325",
        caste: "Kurmi",
      },
      {
        id: "326",
        caste: "Kushwaha (Koiri)",
      },
      {
        id: "326_ALT",
        caste: "Koiri",
      },
      {
        id: "327",
        caste: "Lodhi Rajput",
      },
      {
        id: "328",
        caste: "Mathur",
      },
      {
        id: "329",
        caste: "Naagavamsam",
      },
      {
        id: "330",
        caste: "Nagaralu",
      },
      {
        id: "331",
        caste: "Nambiar",
      },
      {
        id: "332",
        caste: "Brahmin - Narmadiya",
      },
      {
        id: "332_ALT",
        caste: "Narmadiya Brahmin",
      },
      {
        id: "333",
        caste: "Neeli",
      },
      {
        id: "334",
        caste: "Otari",
      },
      {
        id: "335",
        caste: "Partraj",
      },
      {
        id: "336",
        caste: "Perika",
      },
      {
        id: "337",
        caste: "Brahmin - Pushkarna",
      },
      {
        id: "337_ALT",
        caste: "Pushkarna Brahmin",
      },
      {
        id: "338",
        caste: "Relli",
      },
      {
        id: "339",
        caste: "Chattada Sri Vaishnava",
      },
      {
        id: "340",
        caste: "Savji",
      },
      {
        id: "341",
        caste: "Senguntha Mudaliyar",
      },
      {
        id: "342",
        caste: "Sozhiya Vellalar",
      },
      {
        id: "343",
        caste: "Sugali (Naika)",
      },
      {
        id: "343_ALT",
        caste: "Naika",
      },
      {
        id: "344",
        caste: "Sunari",
      },
      {
        id: "346",
        caste: "Togata",
      },
      {
        id: "347",
        caste: "Tonk Kshatriya",
      },
      {
        id: "348",
        caste: "Turupu Kapu",
      },
      {
        id: "349",
        caste: "Urs",
      },
      {
        id: "350",
        caste: "Valluvan",
      },
      {
        id: "351",
        caste: "Variar",
      },
      {
        id: "352",
        caste: "Varshney",
      },
      {
        id: "353",
        caste: "Velaan",
      },
      {
        id: "354",
        caste: "Brahmin - Velanadu",
      },
      {
        id: "354_ALT",
        caste: "Velanadu Brahmin",
      },
      {
        id: "355",
        caste: "Vettuva Gounder",
      },
      {
        id: "356",
        caste: "Vada Balija",
      },
      {
        id: "357",
        caste: "Yellapu",
      },
      {
        id: "358",
        caste: "Raigar",
      },
      {
        id: "400",
        caste: "Muslim - Ansari",
      },
      {
        id: "401",
        caste: "Muslim - Arain",
      },
      {
        id: "402",
        caste: "Muslim - Awan",
      },
      {
        id: "403",
        caste: "Muslim - Bohra",
      },
      {
        id: "404",
        caste: "Muslim - Dekkani",
      },
      {
        id: "405",
        caste: "Muslim - Dudekula",
      },
      {
        id: "406",
        caste: "Muslim - Hanafi",
      },
      {
        id: "407",
        caste: "Muslim - Jat",
      },
      {
        id: "408",
        caste: "Muslim - Khoja",
      },
      {
        id: "409",
        caste: "Muslim - Lebbai",
      },
      {
        id: "410",
        caste: "Muslim - Malik",
      },
      {
        id: "411",
        caste: "Muslim - Mapila",
      },
      {
        id: "412",
        caste: "Muslim - Maraicar",
      },
      {
        id: "413",
        caste: "Muslim - Memon",
      },
      {
        id: "414",
        caste: "Muslim - Mughal",
      },
      {
        id: "415",
        caste: "Muslim - Pathan",
      },
      {
        id: "416",
        caste: "Muslim - Qureshi",
      },
      {
        id: "417",
        caste: "Muslim - Rajput",
      },
      {
        id: "418",
        caste: "Muslim - Rowther",
      },
      {
        id: "419",
        caste: "Muslim - Shafi",
      },
      {
        id: "420",
        caste: "Muslim - Sheikh",
      },
      {
        id: "421",
        caste: "Muslim - Siddiqui",
      },
      {
        id: "422",
        caste: "Muslim - Syed",
      },
      {
        id: "423",
        caste: "Muslim - UnSpecified",
      },
      {
        id: "424",
        caste: "Muslim - Others",
      },
      {
        id: "501",
        caste: "Born Again",
      },
      {
        id: "502",
        caste: "Brethren",
      },
      {
        id: "503",
        caste: "Church of South India",
      },
      {
        id: "504",
        caste: "Evangelist",
      },
      {
        id: "505",
        caste: "Jacobite",
      },
      {
        id: "506",
        caste: "Knanaya",
      },
      {
        id: "507",
        caste: "Knanaya Catholic",
      },
      {
        id: "508",
        caste: "Knanaya Jacobite",
      },
      {
        id: "509",
        caste: "Latin Catholic",
      },
      {
        id: "510",
        caste: "Malankara Catholic",
      },
      {
        id: "511",
        caste: "Marthoma",
      },
      {
        id: "512",
        caste: "Christian - Others",
      },
      {
        id: "513",
        caste: "Pentecost",
      },
      {
        id: "514",
        caste: "Roman Catholic",
      },
      {
        id: "515",
        caste: "Syrian Catholic",
      },
      {
        id: "516",
        caste: "Syrian Jacobite",
      },
      {
        id: "517",
        caste: "Syrian Orthodox",
      },
      {
        id: "518",
        caste: "Syro Malabar",
      },
      {
        id: "519",
        caste: "Not Specified",
      },
      {
        id: "521",
        caste: "Seventh-day Adventist",
      },
      {
        id: "601",
        caste: "Jain - Agarwal",
      },
      {
        id: "602",
        caste: "Jain - Bania",
      },
      {
        id: "603",
        caste: "Jain - Intercaste",
      },
      {
        id: "604",
        caste: "Jain - Jaiswal",
      },
      {
        id: "605",
        caste: "Jain - Khandelwal",
      },
      {
        id: "606",
        caste: "Jain - Kutchi",
      },
      {
        id: "608",
        caste: "Jain - Oswal",
      },
      {
        id: "609",
        caste: "Jain - Others",
      },
      {
        id: "610",
        caste: "Jain - Porwal",
      },
      {
        id: "611",
        caste: "Jain - Unspecified",
      },
      {
        id: "612",
        caste: "Jain - Vaishya",
      },
      {
        id: "613",
        caste: "Jain - KVO",
      },
      {
        id: "614",
        caste: "Jain - Asati",
      },
      {
        id: "615",
        caste: "Jain - Ayodhyavasi",
      },
      {
        id: "616",
        caste: "Jain - Bagherwal",
      },
      {
        id: "617",
        caste: "Jain - Barhiya",
      },
      {
        id: "618",
        caste: "Jain - Charanagare",
      },
      {
        id: "619",
        caste: "Jain - Chaturtha",
      },
      {
        id: "620",
        caste: "Jain - Dhakada",
      },
      {
        id: "621",
        caste: "Jain - Gahoi / Grihapati",
      },
      {
        id: "622",
        caste: "Jain - Golalare / Kharaua",
      },
      {
        id: "623",
        caste: "Jain - Golapurva",
      },
      {
        id: "624",
        caste: "Jain - Golsinghare",
      },
      {
        id: "625",
        caste: "Jain - Harada",
      },
      {
        id: "626",
        caste: "Jain - Humad / Humbad",
      },
      {
        id: "627",
        caste: "Jain - Kambhoja",
      },
      {
        id: "628",
        caste: "Jain - Kasar",
      },
      {
        id: "629",
        caste: "Jain - Kathanere",
      },
      {
        id: "630",
        caste: "Jain - Kharaua",
      },
      {
        id: "631",
        caste: "Jain - Lamechu",
      },
      {
        id: "632",
        caste: "Jain - Nema",
      },
      {
        id: "633",
        caste: "Jain - Padmavati Porwal",
      },
      {
        id: "634",
        caste: "Jain - Palliwal",
      },
      {
        id: "635",
        caste: "Jain - Panchama",
      },
      {
        id: "636",
        caste: "Jain - Parmar",
      },
      {
        id: "637",
        caste: "Jain - Parwar / Paravara",
      },
      {
        id: "638",
        caste: "Jain - Porwad / Porwal",
      },
      {
        id: "639",
        caste: "Jain - Saitwal",
      },
      {
        id: "640",
        caste: "Jain - Samanar / Nayinar",
      },
      {
        id: "641",
        caste: "Jain - Samiya",
      },
      {
        id: "642",
        caste: "Jain - Sarak",
      },
      {
        id: "643",
        caste: "Jain - Shrimal",
      },
      {
        id: "644",
        caste: "Jain - Upadhyaya",
      },
      {
        id: "645",
        caste: "Jain - Veerwal",
      },
      {
        id: "651",
        caste: "Sikh - Ahluwalia",
      },
      {
        id: "652",
        caste: "Sikh - Arora",
      },
      {
        id: "653",
        caste: "Sikh - Bhatia",
      },
      {
        id: "654",
        caste: "Sikh - Ghumar",
      },
      {
        id: "655",
        caste: "Sikh - Intercaste",
      },
      {
        id: "656",
        caste: "Sikh - Jat",
      },
      {
        id: "657",
        caste: "Sikh - Kamboj",
      },
      {
        id: "658",
        caste: "Sikh - Khatri",
      },
      {
        id: "659",
        caste: "Sikh - Kshatriya",
      },
      {
        id: "660",
        caste: "Sikh - Lubana",
      },
      {
        id: "661",
        caste: "Sikh - Majabi",
      },
      {
        id: "663",
        caste: "Sikh - Others",
      },
      {
        id: "664",
        caste: "Sikh - Rajput",
      },
      {
        id: "665",
        caste: "Sikh - Ramdasia",
      },
      {
        id: "666",
        caste: "Sikh - Ramgharia",
      },
      {
        id: "667",
        caste: "Sikh - Saini",
      },
      {
        id: "668",
        caste: "Sikh - Unspecified",
      },
      {
        id: "669",
        caste: "Sikh - Ravidasia",
      },
      {
        id: "670",
        caste: "Sikh - Bhatra",
      },
      {
        id: "671",
        caste: "Sikh - Tonk Kshatriya",
      },
      {
        id: "672",
        caste: "Sikh - Nai",
      },
      {
        id: "673",
        caste: "Badaga",
      },
      {
        id: "675",
        caste: "Thakore",
      },
      {
        id: "676",
        caste: "Pathare Prabhu",
      },
      {
        id: "677",
        caste: "Lohar",
      },
      {
        id: "680",
        caste: "Brahmin - Gujar Gaur",
      },
      {
        id: "680_ALT",
        caste: "Gujar Gaur Brahmin",
      },
      {
        id: "681",
        caste: "Brahmin - Sikhwal",
      },
      {
        id: "681_ALT",
        caste: "Sikhwal Brahmin",
      },
      {
        id: "682",
        caste: "Srisayana",
      },
      {
        id: "683",
        caste: "Poosala",
      },
      {
        id: "684",
        caste: "Ganda",
      },
      {
        id: "685",
        caste: "Ayyaraka",
      },
      {
        id: "686",
        caste: "Rajbhar",
      },
      {
        id: "687",
        caste: "Brahmin - Vaikhanasa",
      },
      {
        id: "687_ALT",
        caste: "Vaikhanasa Brahmin",
      },
      {
        id: "688",
        caste: "Pandaram",
      },
      {
        id: "689",
        caste: "Koli Mahadev",
      },
      {
        id: "690",
        caste: "Bishnoi/Vishnoi",
      },
      {
        id: "691",
        caste: "Kahar",
      },
      {
        id: "692",
        caste: "Adi Andhra",
      },
      {
        id: "693",
        caste: "Adi Karnataka",
      },
      {
        id: "694",
        caste: "Brahmin - Paliwal",
      },
      {
        id: "695",
        caste: "Kalal",
      },
      {
        id: "696",
        caste: "Urali Gounder",
      },
      {
        id: "698",
        caste: "Bagdi",
      },
      {
        id: "699",
        caste: "Bajantri",
      },
      {
        id: "700",
        caste: "Banayat Oriya",
      },
      {
        id: "701",
        caste: "Baniya - Bania",
      },
      {
        id: "702",
        caste: "Baniya - Kumuti",
      },
      {
        id: "703",
        caste: "Baria",
      },
      {
        id: "704",
        caste: "Bhoi",
      },
      {
        id: "705",
        caste: "Bondili",
      },
      {
        id: "706",
        caste: "Brahmin - Khandelwal",
      },
      {
        id: "707",
        caste: "Brahmin - Jyotish",
      },
      {
        id: "708",
        caste: "Brahmin - Pareek",
      },
      {
        id: "709",
        caste: "Brajastha Maithil",
      },
      {
        id: "711",
        caste: "Chennadasar",
      },
      {
        id: "712",
        caste: "Dommala",
      },
      {
        id: "713",
        caste: "Gatti",
      },
      {
        id: "714",
        caste: "Halba Koshti",
      },
      {
        id: "715",
        caste: "Helava",
      },
      {
        id: "716",
        caste: "Jetty/Malla",
      },
      {
        id: "717",
        caste: "Kavuthiyya/Ezhavathy",
      },
      {
        id: "718",
        caste: "Kharwa",
      },
      {
        id: "719",
        caste: "Kirar",
      },
      {
        id: "720",
        caste: "Koli Patel",
      },
      {
        id: "721",
        caste: "Korama",
      },
      {
        id: "722",
        caste: "Kosthi",
      },
      {
        id: "723",
        caste: "Krishnavaka",
      },
      {
        id: "724",
        caste: "Loniya",
      },
      {
        id: "725",
        caste: "Rajpurohit",
      },
      {
        id: "726",
        caste: "Ramanandi",
      },
      {
        id: "727",
        caste: "Ramoshi",
      },
      {
        id: "728",
        caste: "Ror",
      },
      {
        id: "729",
        caste: "Surya Balija",
      },
      {
        id: "730",
        caste: "Vanika Vyshya",
      },
      {
        id: "731",
        caste: "Jijhotia Brahmin",
      },
      {
        id: "731_ALT",
        caste: "Brahmin Jijhotia",
      },
      {
        id: "732",
        caste: "Dhor / Kakkayya",
      },
      {
        id: "733",
        caste: "Malviya Brahmin",
      },
      {
        id: "733_ALT",
        caste: "Brahmin Malviya",
      },
      {
        id: "734",
        caste: "Brahmin - Embrandiri",
      },
      {
        id: "734_ALT",
        caste: "Embrandiri Brahmin",
      },
      {
        id: "735",
        caste: "Maurya / Shakya",
      },
      {
        id: "736",
        caste: "Sathwara",
      },
      {
        id: "737",
        caste: "Bhoyar",
      },
      {
        id: "738",
        caste: "Chalawadi and Holeya",
      },
      {
        id: "739",
        caste: "Kalanji",
      },
      {
        id: "740",
        caste: "Devrukhe Brahmin",
      },
      {
        id: "741",
        caste: "Ahir Shimpi",
      },
      {
        id: "742",
        caste: "Balija Naidu",
      },
      {
        id: "743",
        caste: "Ediga /Goud (Balija)",
      },
      {
        id: "744",
        caste: "Gajula / Kavarai",
      },
      {
        id: "748",
        caste: "Setty Balija",
      },
      {
        id: "750",
        caste: "Kavara",
      },
      {
        id: "751",
        caste: "Linga Balija",
      },
      {
        id: "752",
        caste: "Musukama",
      },
      {
        id: "753",
        caste: "Namdarlu",
      },
      {
        id: "754",
        caste: "Pagadala",
      },
      {
        id: "755",
        caste: "Balija Reddy",
      },
      {
        id: "756",
        caste: "Thota",
      },
      {
        id: "757",
        caste: "Komti /Arya Vaishya",
      },
      {
        id: "758",
        caste: "Thiyya Thandan",
      },
      {
        id: "759",
        caste: "Madhesiya/Kanu/Halwai",
      },
      {
        id: "760",
        caste: "Shaw / Sahu/Teli",
      },
      {
        id: "761",
        caste: "Nabit",
      },
      {
        id: "762",
        caste: "Brahmin - Dadhich",
      },
      {
        id: "763",
        caste: "Brahmin - Koteshwara / Kota (Madhwa )",
      },
      {
        id: "764",
        caste: "Brahmin - Shivalli (Madhva)",
      },
      {
        id: "765",
        caste: "Brahmin - Shukla Yajurvedi",
      },
      {
        id: "766",
        caste: "24 Manai Telugu Chettiar",
      },
      {
        id: "767",
        caste: "Modikarlu",
      },
      {
        id: "768",
        caste: "Gandla / Ganiga",
      },
      {
        id: "769",
        caste: "Parvatha Rajakulam",
      },
      {
        id: "770",
        caste: "Pattinavar",
      },
      {
        id: "771",
        caste: "Sadhu Chetty",
      },
      {
        id: "772",
        caste: "Telugupatti",
      },
      {
        id: "775",
        caste: "Ezhava Panicker",
      },
      {
        id: "776",
        caste: "Ezhava Thandan",
      },
      {
        id: "777",
        caste: "Gounder - Kongu Vellala Gounder",
      },
      {
        id: "778",
        caste: "Gounder - Nattu Gounder",
      },
      {
        id: "779",
        caste: "Gounder - Urali Gounder",
      },
      {
        id: "780",
        caste: "Gounder - Vanniya Kula Kshatriyar",
      },
      {
        id: "781",
        caste: "Gounder - Vettuva Gounder",
      },
      {
        id: "782",
        caste: "Gowda - Kuruba Gowda",
      },
      {
        id: "783",
        caste: "Kanykubj Bania",
      },
      {
        id: "785",
        caste: "Kapu Naidu",
      },
      {
        id: "786",
        caste: "Ontari",
      },
      {
        id: "787",
        caste: "Kayastha (Bengali)",
      },
      {
        id: "788",
        caste: "Nattu Gounder",
      },
      {
        id: "790",
        caste: "Perika/Puragiri Kshatriya",
      },
      {
        id: "791",
        caste: "Thogata Veera Kshatriya",
      },
      {
        id: "792",
        caste: "Haihaivanshi",
      },
      {
        id: "793",
        caste: "Kshatriya Kurmi",
      },
      {
        id: "797",
        caste: "96 Kuli Maratha",
      },
      {
        id: "800",
        caste: "Aramari / Gabit",
      },
      {
        id: "801",
        caste: "Deshmukh",
      },
      {
        id: "802",
        caste: "Jhadav",
      },
      {
        id: "803",
        caste: "Maratha Kshatriya",
      },
      {
        id: "804",
        caste: "Kunbi Lonari",
      },
      {
        id: "805",
        caste: "Kunbi Maratha",
      },
      {
        id: "806",
        caste: "Kunbi Tirale",
      },
      {
        id: "807",
        caste: "Malwani",
      },
      {
        id: "808",
        caste: "Patil",
      },
      {
        id: "810",
        caste: "Saiva Pillai Tirunelveli",
      },
      {
        id: "811",
        caste: "Sengunthar/Kaikolar",
      },
      {
        id: "812",
        caste: "Thondai Mandala Vellalar",
      },
      {
        id: "813",
        caste: "Kongu Nadar",
      },
      {
        id: "814",
        caste: "Naicker - Vanniya Kula Kshatriyar",
      },
      {
        id: "816",
        caste: "Kamma Naidu",
      },
      {
        id: "818",
        caste: "Vadugan",
      },
      {
        id: "819",
        caste: "Yadava Naidu",
      },
      {
        id: "821",
        caste: "Vilakithala Nair",
      },
      {
        id: "823",
        caste: "Brahmin - Anaviln Desai",
      },
      {
        id: "827",
        caste: "Brahmin - Shri Gaud",
      },
      {
        id: "832",
        caste: "Brahmin - Rarhi/Radhi",
      },
      {
        id: "834",
        caste: "Brahmin - Baidhiki/Vaidhiki",
      },
      {
        id: "835",
        caste: "Brahmin - Khedaval",
      },
      {
        id: "836",
        caste: "Thogata Veerakshathriya",
      },
      {
        id: "839",
        caste: "Anjana (Chowdary) Patel",
      },
      {
        id: "840",
        caste: "Desikar",
      },
      {
        id: "841",
        caste: "Karkathar",
      },
      {
        id: "842",
        caste: "Othuvaar",
      },
      {
        id: "843",
        caste: "Saiva Pillai Thanjavur",
      },
      {
        id: "844",
        caste: "Desikar Thanjavur",
      },
      {
        id: "845",
        caste: "Pallan / Devandra Kula Vellalan",
      },
      {
        id: "849",
        caste: "Kori/Koli",
      },
      {
        id: "850",
        caste: "Kuruva",
      },
      {
        id: "851",
        caste: "Rohit / Chamar",
      },
      {
        id: "852",
        caste: "Sambava",
      },
      {
        id: "853",
        caste: "Vaishnav Dishaval",
      },
      {
        id: "854",
        caste: "Vaishnav Kapol",
      },
      {
        id: "855",
        caste: "Vaishnav Khadyata",
      },
      {
        id: "856",
        caste: "Vaishnav Lad",
      },
      {
        id: "857",
        caste: "Vaishnav Modh",
      },
      {
        id: "858",
        caste: "Vaishnav Porvad",
      },
      {
        id: "859",
        caste: "Vaishnav Shrimali",
      },
      {
        id: "860",
        caste: "Vaishnav Sorathaiya",
      },
      {
        id: "861",
        caste: "Vaishnav Vania",
      },
      {
        id: "862",
        caste: "Agrahari",
      },
      {
        id: "863",
        caste: "Asathi",
      },
      {
        id: "864",
        caste: "Barnwal",
      },
      {
        id: "865",
        caste: "Dosar / Dusra",
      },
      {
        id: "866",
        caste: "Gahoi",
      },
      {
        id: "867",
        caste: "Kasaundhan",
      },
      {
        id: "868",
        caste: "Keshri (Kesarwani)",
      },
      {
        id: "869",
        caste: "Maheshwari / Meshri",
      },
      {
        id: "870",
        caste: "Mahuri",
      },
      {
        id: "871",
        caste: "Nema",
      },
      {
        id: "872",
        caste: "Patwa",
      },
      {
        id: "873",
        caste: "Porwal / Porwar",
      },
      {
        id: "874",
        caste: "Rastogi",
      },
      {
        id: "875",
        caste: "Rauniar",
      },
      {
        id: "876",
        caste: "Ummar / Umre / Bagaria",
      },
      {
        id: "877",
        caste: "Vani / Vaishya",
      },
      {
        id: "878",
        caste: "Varshney (Barahseni)",
      },
      {
        id: "879",
        caste: "Vijayvargia",
      },
      {
        id: "880",
        caste: "Choudhary",
      },
      {
        id: "881",
        caste: "Gandha Vanika",
      },
      {
        id: "882",
        caste: "Lad",
      },
      {
        id: "883",
        caste: "Modi",
      },
      {
        id: "884",
        caste: "Padmavati Porwal",
      },
      {
        id: "885",
        caste: "Rathi",
      },
      {
        id: "886",
        caste: "Devanga Chettiar",
      },
      {
        id: "887",
        caste: "Kuruhini Chetty",
      },
      {
        id: "888",
        caste: "Padmashali",
      },
      {
        id: "889",
        caste: "Pattusali",
      },
      {
        id: "890",
        caste: "Achirapakkam Chettiar",
      },
      {
        id: "891",
        caste: "Agaram Vellan Chettiar",
      },
      {
        id: "892",
        caste: "Ayira Vysya",
      },
      {
        id: "893",
        caste: "Beri Chettiar",
      },
      {
        id: "894",
        caste: "Elur Chetty",
      },
      {
        id: "895",
        caste: "Kasukara",
      },
      {
        id: "896",
        caste: "Kongu Chettiar",
      },
      {
        id: "897",
        caste: "Manjapudur Chettiar",
      },
      {
        id: "898",
        caste: "Nattukottai Chettiar",
      },
      {
        id: "899",
        caste: "Pannirandam Chettiar",
      },
      {
        id: "900",
        caste: "Sozhia Chetty",
      },
      {
        id: "901",
        caste: "Vadambar",
      },
      {
        id: "902",
        caste: "Vaniya Chettiar",
      },
      {
        id: "903",
        caste: "Vellan Chettiars",
      },
      {
        id: "904",
        caste: "Gounder - Others",
      },
      {
        id: "923",
        caste: "Ayodhyavasi",
      },
      {
        id: "924",
        caste: "Chaturth",
      },
      {
        id: "925",
        caste: "Gulahre",
      },
      {
        id: "926",
        caste: "Mahor",
      },
      {
        id: "927",
        caste: "Mathur Vaishya",
      },
      {
        id: "928",
        caste: "Kapu Reddy",
      },
      {
        id: "929",
        caste: "Kshatriya Raju",
      },
      {
        id: "933",
        caste: "Parit",
      },
      {
        id: "934",
        caste: "Vani",
      },
      {
        id: "935",
        caste: "Agamudayar / Arcot / Thuluva Vellala",
      },
      {
        id: "936",
        caste: "Isai Vellalar",
      },
      {
        id: "937",
        caste: "Veerakodi Vellala",
      },
      {
        id: "938",
        caste: "Kerala Mudali",
      },
      {
        id: "939",
        caste: "Naicker - Others",
      },
      {
        id: "942",
        caste: "Brahmin - Shri Mali",
      },
      {
        id: "943",
        caste: "Brahmin - Bardai",
      },
      {
        id: "944",
        caste: "Brahmin - Bhargav",
      },
      {
        id: "945",
        caste: "Brahmin - Khadayata",
      },
      {
        id: "946",
        caste: "Brahmin - Mevada",
      },
      {
        id: "947",
        caste: "Brahmin - Rajgor",
      },
      {
        id: "948",
        caste: "Brahmin - Sarua",
      },
      {
        id: "949",
        caste: "Brahmin - Tapodhan",
      },
      {
        id: "950",
        caste: "Brahmin - Valam",
      },
      {
        id: "951",
        caste: "Brahmin - Zalora",
      },
      {
        id: "954",
        caste: "Swakula Saali",
      },
      {
        id: "955",
        caste: "Kaikaala",
      },
      {
        id: "956",
        caste: "Karakala Bhakthula",
      },
      {
        id: "957",
        caste: "Karni Bhakthula",
      },
      {
        id: "958",
        caste: "Kurni",
      },
      {
        id: "959",
        caste: "Neeli Saali",
      },
      {
        id: "960",
        caste: "Nessi",
      },
      {
        id: "961",
        caste: "Shettigar",
      },
      {
        id: "962",
        caste: "Brahmin - Panicker",
      },
      {
        id: "963",
        caste: "Aaru Nattu Vellala",
      },
      {
        id: "965",
        caste: "Cherakula Vellalar",
      },
      {
        id: "966",
        caste: "Illaththu Pillai",
      },
      {
        id: "968",
        caste: "Kodikal Pillai",
      },
      {
        id: "969",
        caste: "Nanjil Mudali",
      },
      {
        id: "970",
        caste: "Nankudi Vellalar",
      },
      {
        id: "971",
        caste: "Pandiya Vellalar",
      },
      {
        id: "973",
        caste: "Nanjil pillai",
      },
      {
        id: "974",
        caste: "Kumaoni Rajput",
      },
      {
        id: "975",
        caste: "Mair Rajput Swarnkar",
      },
      {
        id: "976",
        caste: "Paswan / Dusadh",
      },
      {
        id: "977",
        caste: "Ahirwar",
      },
      {
        id: "978",
        caste: "Bairwa",
      },
      {
        id: "979",
        caste: "Balai",
      },
      {
        id: "980",
        caste: "Dhanak",
      },
      {
        id: "981",
        caste: "Julaha",
      },
      {
        id: "982",
        caste: "Kanakkan Padanna",
      },
      {
        id: "983",
        caste: "Kandara",
      },
      {
        id: "984",
        caste: "Khatik",
      },
      {
        id: "985",
        caste: "Mannan / Velan / Vannan",
      },
      {
        id: "986",
        caste: "Meghwal",
      },
      {
        id: "987",
        caste: "Panan",
      },
      {
        id: "988",
        caste: "Paravan / Bharatar",
      },
      {
        id: "989",
        caste: "Poundra",
      },
      {
        id: "990",
        caste: "Pulaya / Cheruman",
      },
      {
        id: "991",
        caste: "Samagar",
      },
      {
        id: "992",
        caste: "Satnami",
      },
      {
        id: "993",
        caste: "Shilpkar",
      },
      {
        id: "994",
        caste: "Sonkar",
      },
      {
        id: "995",
        caste: "Thandan",
      },
      {
        id: "996",
        caste: "Vettuvan",
      },
      {
        id: "999",
        caste: "Other Caste",
      },
      {
        id: "1007",
        caste: "Nanjil Nattu Vellalar",
      },
      {
        id: "1008",
        caste: "Nanjil Vellalar",
      },
      {
        id: "1009",
        caste: "Oraon",
      },
      {
        id: "1010",
        caste: "Arakh / Arakvanshiya",
      },
      {
        id: "1011",
        caste: "Poddar",
      },
      {
        id: "1012",
        caste: "Saiva Vellan chettiar",
      },
      {
        id: "1013",
        caste: "Gavandi",
      },
      {
        id: "1014",
        caste: "Bhulia / Meher",
      },
      {
        id: "1015",
        caste: "Valsad",
      },
      {
        id: "1016",
        caste: "Modh Ghanchi",
      },
      {
        id: "1017",
        caste: "Anglo-Indian",
      },
      {
        id: "1018",
        caste: "Sikh - Rai",
      },
      {
        id: "1023",
        caste: "Swarnakar",
      },
      {
        id: "1024",
        caste: "Gond",
      },
      {
        id: "1025",
        caste: "Aguri / Ugra Kshatriya",
      },
      {
        id: "1026",
        caste: "Charan",
      },
      {
        id: "1027",
        caste: "Shah",
      },
      {
        id: "1028",
        caste: "Brahmakshtriya",
      },
      {
        id: "1029",
        caste: "Matia Patel",
      },
      {
        id: "1030",
        caste: "Kadia",
      },
      {
        id: "1031",
        caste: "Bhil",
      },
      {
        id: "1034",
        caste: "Aheriya",
      },
      {
        id: "1035",
        caste: "Kansyakaar",
      },
      {
        id: "1038",
        caste: "Amma Kodava",
      },
      {
        id: "1040",
        caste: "Heggade",
      },
      {
        id: "1041",
        caste: "Kodava",
      },
      {
        id: "1042",
        caste: "Chakkala Nair",
      },
      {
        id: "1043",
        caste: "Vellala Pillai",
      },
      {
        id: "1044",
        caste: "Tharakan",
      },
      {
        id: "1045",
        caste: "Mannadiyar",
      },
      {
        id: "1046",
        caste: "Odan",
      },
      {
        id: "1047",
        caste: "Valar",
      },
      {
        id: "1048",
        caste: "Holar",
      },
      {
        id: "1050",
        caste: "Vadar",
      },
      {
        id: "1053",
        caste: "Niari",
      },
      {
        id: "1054",
        caste: "Raju / Kshatriya Raju",
      },
      {
        id: "1055",
        caste: "Gopal / Gopala",
      },
      {
        id: "1056",
        caste: "Laxminarayan gola",
      },
      {
        id: "1057",
        caste: "Radhi / Niari",
      },
      {
        id: "1061",
        caste: "Saliyar",
      },
      {
        id: "1062",
        caste: "Dasapalanjika / Kannada Saineegar",
      },
      {
        id: "1063",
        caste: "Tammali",
      },
      {
        id: "1064",
        caste: "Vanyakulakshatriya",
      },
      {
        id: "1065",
        caste: "Protestant",
      },
      {
        id: "1066",
        caste: "Assembly of God (AG)",
      },
      {
        id: "1067",
        caste: "Church of God",
      },
      {
        id: "1068",
        caste: "Baptist",
      },
      {
        id: "1069",
        caste: "Adventist",
      },
      {
        id: "1070",
        caste: "Anglican / Episcopal",
      },
      {
        id: "1071",
        caste: "Jehovah's Witnesses",
      },
      {
        id: "1072",
        caste: "Methodist",
      },
      {
        id: "1073",
        caste: "Chaldean Syrian (Assyrian)",
      },
      {
        id: "1074",
        caste: "Lutheran",
      },
      {
        id: "1075",
        caste: "Mennonite",
      },
      {
        id: "1076",
        caste: "Calvinist",
      },
      {
        id: "1077",
        caste: "Congregational",
      },
      {
        id: "1078",
        caste: "Presbyterian",
      },
      {
        id: "1079",
        caste: "Latter day saints",
      },
      {
        id: "1080",
        caste: "Apostolic",
      },
      {
        id: "1081",
        caste: "Church of Christ",
      },
      {
        id: "1082",
        caste: "Church of North India",
      },
      {
        id: "1083",
        caste: "Melkite",
      },
      {
        id: "1084",
        caste: "Moravian",
      },
      {
        id: "1085",
        caste: "Orthodox",
      },
      {
        id: "1086",
        caste: "Malabar Independent Syrian Church",
      },
      {
        id: "1087",
        caste: "St. Thomas Evangelical",
      },
      {
        id: "1088",
        caste: "Reformed Baptist",
      },
      {
        id: "1089",
        caste: "Reformed Presbyterian",
      },
      {
        id: "2309",
        caste: "Neo Buddhist",
      },
      {
        id: "2310",
        caste: "Tibetan Buddhist",
      },
      {
        id: "2311",
        caste: "Others",
      },
      {
        id: "2312",
        caste: "Dhanuk",
      },
      {
        id: "2313",
        caste: "Bairagi",
      },
      {
        id: "2314",
        caste: "Baori",
      },
      {
        id: "2315",
        caste: "Bargi",
      },
      {
        id: "2316",
        caste: "Bavaria",
      },
      {
        id: "2317",
        caste: "Bazigar",
      },
      {
        id: "2318",
        caste: "Beldar",
      },
      {
        id: "2319",
        caste: "Bhand",
      },
      {
        id: "2320",
        caste: "Brahmin - Bagra",
      },
      {
        id: "2321",
        caste: "Brahmin - Baragaon",
      },
      {
        id: "2322",
        caste: "Brahmin - Bhojak",
      },
      {
        id: "2323",
        caste: "Brahmin - Chaubisa",
      },
      {
        id: "2324",
        caste: "Brahmin - Dakaut",
      },
      {
        id: "2325",
        caste: "Dhakad",
      },
      {
        id: "2326",
        caste: "Dhanka",
      },
      {
        id: "2327",
        caste: "Garo / Garoda",
      },
      {
        id: "2328",
        caste: "Gavaria",
      },
      {
        id: "2329",
        caste: "Jingar",
      },
      {
        id: "2330",
        caste: "Kalbelia",
      },
      {
        id: "2331",
        caste: "Kandera",
      },
      {
        id: "2332",
        caste: "Kanjar",
      },
      {
        id: "2333",
        caste: "Kokna",
      },
      {
        id: "2334",
        caste: "Mehar",
      },
      {
        id: "2335",
        caste: "Nat",
      },
      {
        id: "2336",
        caste: "Rabari",
      },
      {
        id: "2337",
        caste: "Ravana Rajput",
      },
      {
        id: "2338",
        caste: "Sahariya",
      },
      {
        id: "2339",
        caste: "Salvi",
      },
      {
        id: "2340",
        caste: "Sansi",
      },
      {
        id: "2341",
        caste: "Sargara",
      },
      {
        id: "2342",
        caste: "Sirvi / Janwa",
      },
      {
        id: "2343",
        caste: "Sondhia",
      },
      {
        id: "2344",
        caste: "Bhar",
      },
      {
        id: "2345",
        caste: "Bharbhunja",
      },
      {
        id: "2346",
        caste: "Bind",
      },
      {
        id: "2347",
        caste: "Chero",
      },
      {
        id: "2348",
        caste: "Gandharb",
      },
      {
        id: "2349",
        caste: "Musahar",
      },
      {
        id: "2350",
        caste: "Tiyar/Tiar",
      },
      {
        id: "2376",
        caste: "Kasera",
      },
      {
        id: "2377",
        caste: "Lakhara / Lakhera / Laxkar",
      },
    ],
  },

  {
    id: "16",
    name: "No Religious Belief",
    castealias: "Caste",
    castes: [
      {
        id: "0",
        name: "Others",
      },
    ],
  },
];
